import { j as mo } from "./jsx-runtime-p91LotPX.mjs";
import * as r from "react";
import j, { useState as vn, useRef as Yt, useEffect as tn, useContext as fo } from "react";
import { q as xe, p as zt, i as fe, J as go, _ as ve, Q as po, f as ie, o as Ee, z as _t, w as Le, aj as vo, v as Qe, G as ho, t as bo, af as So, U as Co, ak as hn, a as ln, b as Kt, ah as nn, m as Rt, u as Y, ai as Tn, g as Bn, s as Vn, n as jn, D as yo, Y as wo, c as bn, K as $o, al as Io } from "./index-CjjiqU7h.mjs";
import { A as Ut } from "./AntdIcon-EfV3m8Ts.mjs";
import { F as xo, s as Eo, a as Oo, b as No, c as Po, i as Sn, R as Cn, L as yn } from "./LeftOutlined-Cz5Dhn8F.mjs";
import { u as jt, a as Do } from "./useCSSVarCls--o7XUl-F.mjs";
import { K as T, g as Mo } from "./motion-P3tHGbiP.mjs";
import { p as Ht } from "./pickAttrs-bNG7_x1p.mjs";
import { a as Ro, u as Hn } from "./Compact-8zmhZt2C.mjs";
import { u as zo } from "./useBreakpoint-C_VPG-kZ.mjs";
import { T as _o, i as To } from "./index-z2Yki-8P.mjs";
import { o as An } from "./omit-B_u6A-HL.mjs";
import { L as Bo } from "./List-Bf4pLkNs.mjs";
import { t as on } from "./toArray-C1Af_up9.mjs";
import { u as Vo } from "./Portal-CYsTveh8.mjs";
import { g as jo } from "./PurePanel-Bpm-3pHm.mjs";
import { C as Ho, b as Ao, c as Lo, g as Fo, a as Wo, i as Ko, d as Uo, e as Xo, f as Go, h as qo } from "./index-DIiEiQf8.mjs";
import { E as Vt } from "./index-CXEaQcuD.mjs";
import { F as Jo } from "./context-CqAjIyj3.mjs";
import { g as Yo } from "./compact-item-DH13cl8A.mjs";
import { i as wn } from "./move-CodNxzZd.mjs";
import { C as Qo } from "./CloseCircleFilled-MnFa8sCv.mjs";
import { C as Zo } from "./CloseOutlined-C-avmD02.mjs";
import { L as ko } from "./LoadingOutlined-CwpxM4LT.mjs";
import { u as ei } from "./useLocale-BP_KijF7.mjs";
var Xt = function(t) {
  var n = t.className, o = t.customizeIcon, i = t.customizeIconProps, a = t.children, l = t.onMouseDown, s = t.onClick, u = typeof o == "function" ? o(i) : o;
  return /* @__PURE__ */ r.createElement("span", {
    className: n,
    onMouseDown: function(d) {
      d.preventDefault(), l == null || l(d);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: s,
    "aria-hidden": !0
  }, u !== void 0 ? u : /* @__PURE__ */ r.createElement("span", {
    className: xe(n.split(/\s+/).map(function(g) {
      return "".concat(g, "-icon");
    }))
  }, a));
}, ti = function(t, n, o, i, a) {
  var l = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, s = arguments.length > 6 ? arguments[6] : void 0, u = arguments.length > 7 ? arguments[7] : void 0, g = j.useMemo(function() {
    if (zt(i) === "object")
      return i.clearIcon;
    if (a)
      return a;
  }, [i, a]), d = j.useMemo(function() {
    return !!(!l && i && (o.length || s) && !(u === "combobox" && s === ""));
  }, [i, l, o.length, s, u]);
  return {
    allowClear: d,
    clearIcon: /* @__PURE__ */ j.createElement(Xt, {
      className: "".concat(t, "-clear"),
      onMouseDown: n,
      customizeIcon: g
    }, "×")
  };
}, Ln = /* @__PURE__ */ r.createContext(null);
function ni() {
  return r.useContext(Ln);
}
function oi() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, t = r.useState(!1), n = fe(t, 2), o = n[0], i = n[1], a = r.useRef(null), l = function() {
    window.clearTimeout(a.current);
  };
  r.useEffect(function() {
    return l;
  }, []);
  var s = function(g, d) {
    l(), a.current = window.setTimeout(function() {
      i(g), d && d();
    }, e);
  };
  return [o, s, l];
}
function Fn() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, t = r.useRef(null), n = r.useRef(null);
  r.useEffect(function() {
    return function() {
      window.clearTimeout(n.current);
    };
  }, []);
  function o(i) {
    (i || t.current === null) && (t.current = i), window.clearTimeout(n.current), n.current = window.setTimeout(function() {
      t.current = null;
    }, e);
  }
  return [function() {
    return t.current;
  }, o];
}
function ii(e, t, n, o) {
  var i = r.useRef(null);
  i.current = {
    open: t,
    triggerOpen: n,
    customizedTrigger: o
  }, r.useEffect(function() {
    function a(l) {
      var s;
      if (!((s = i.current) !== null && s !== void 0 && s.customizedTrigger)) {
        var u = l.target;
        u.shadowRoot && l.composed && (u = l.composedPath()[0] || u), i.current.open && e().filter(function(g) {
          return g;
        }).every(function(g) {
          return !g.contains(u) && g !== u;
        }) && i.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", a), function() {
      return window.removeEventListener("mousedown", a);
    };
  }, []);
}
function ri(e) {
  return ![
    // System function button
    T.ESC,
    T.SHIFT,
    T.BACKSPACE,
    T.TAB,
    T.WIN_KEY,
    T.ALT,
    T.META,
    T.WIN_KEY_RIGHT,
    T.CTRL,
    T.SEMICOLON,
    T.EQUALS,
    T.CAPS_LOCK,
    T.CONTEXT_MENU,
    // F1-F12
    T.F1,
    T.F2,
    T.F3,
    T.F4,
    T.F5,
    T.F6,
    T.F7,
    T.F8,
    T.F9,
    T.F10,
    T.F11,
    T.F12
  ].includes(e);
}
var ai = function(t, n) {
  var o, i = t.prefixCls, a = t.id, l = t.inputElement, s = t.disabled, u = t.tabIndex, g = t.autoFocus, d = t.autoComplete, m = t.editable, $ = t.activeDescendantId, c = t.value, b = t.maxLength, v = t.onKeyDown, f = t.onMouseDown, w = t.onChange, p = t.onPaste, F = t.onCompositionStart, z = t.onCompositionEnd, W = t.open, D = t.attrs, M = l || /* @__PURE__ */ r.createElement("input", null), X = M, Z = X.ref, H = X.props, J = H.onKeyDown, G = H.onChange, ee = H.onMouseDown, I = H.onCompositionStart, N = H.onCompositionEnd, te = H.style;
  return go(!("maxLength" in M.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), M = /* @__PURE__ */ r.cloneElement(M, ve(ve(ve({
    type: "search"
  }, H), {}, {
    // Override over origin props
    id: a,
    ref: po(n, Z),
    disabled: s,
    tabIndex: u,
    autoComplete: d || "off",
    autoFocus: g,
    className: xe("".concat(i, "-selection-search-input"), (o = M) === null || o === void 0 || (o = o.props) === null || o === void 0 ? void 0 : o.className),
    role: "combobox",
    "aria-expanded": W || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(a, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(a, "_list"),
    "aria-activedescendant": W ? $ : void 0
  }, D), {}, {
    value: m ? c : "",
    maxLength: b,
    readOnly: !m,
    unselectable: m ? null : "on",
    style: ve(ve({}, te), {}, {
      opacity: m ? null : 0
    }),
    onKeyDown: function(C) {
      v(C), J && J(C);
    },
    onMouseDown: function(C) {
      f(C), ee && ee(C);
    },
    onChange: function(C) {
      w(C), G && G(C);
    },
    onCompositionStart: function(C) {
      F(C), I && I(C);
    },
    onCompositionEnd: function(C) {
      z(C), N && N(C);
    },
    onPaste: p
  })), M;
}, cn = /* @__PURE__ */ r.forwardRef(ai);
process.env.NODE_ENV !== "production" && (cn.displayName = "Input");
function sn(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
var li = typeof window < "u" && window.document && window.document.documentElement, ci = process.env.NODE_ENV !== "test" && li;
function si(e) {
  return e != null;
}
function ui(e) {
  return !e && e !== 0;
}
function $n(e) {
  return ["string", "number"].includes(zt(e));
}
function Wn(e) {
  var t = void 0;
  return e && ($n(e.title) ? t = e.title.toString() : $n(e.label) && (t = e.label.toString())), t;
}
function di(e, t) {
  ci ? r.useLayoutEffect(e, t) : r.useEffect(e, t);
}
function mi(e) {
  var t;
  return (t = e.key) !== null && t !== void 0 ? t : e.value;
}
var In = function(t) {
  t.preventDefault(), t.stopPropagation();
}, fi = function(t) {
  var n = t.id, o = t.prefixCls, i = t.values, a = t.open, l = t.searchValue, s = t.autoClearSearchValue, u = t.inputRef, g = t.placeholder, d = t.disabled, m = t.mode, $ = t.showSearch, c = t.autoFocus, b = t.autoComplete, v = t.activeDescendantId, f = t.tabIndex, w = t.removeIcon, p = t.maxTagCount, F = t.maxTagTextLength, z = t.maxTagPlaceholder, W = z === void 0 ? function(q) {
    return "+ ".concat(q.length, " ...");
  } : z, D = t.tagRender, M = t.onToggleOpen, X = t.onRemove, Z = t.onInputChange, H = t.onInputPaste, J = t.onInputKeyDown, G = t.onInputMouseDown, ee = t.onInputCompositionStart, I = t.onInputCompositionEnd, N = r.useRef(null), te = vn(0), A = fe(te, 2), C = A[0], K = A[1], Q = vn(!1), Oe = fe(Q, 2), Re = Oe[0], se = Oe[1], ae = "".concat(o, "-selection"), ue = a || m === "multiple" && s === !1 || m === "tags" ? l : "", Fe = m === "tags" || m === "multiple" && s === !1 || $ && (a || Re);
  di(function() {
    K(N.current.scrollWidth);
  }, [ue]);
  var le = function(O, L, h, ce, re) {
    return /* @__PURE__ */ r.createElement("span", {
      title: Wn(O),
      className: xe("".concat(ae, "-item"), ie({}, "".concat(ae, "-item-disabled"), h))
    }, /* @__PURE__ */ r.createElement("span", {
      className: "".concat(ae, "-item-content")
    }, L), ce && /* @__PURE__ */ r.createElement(Xt, {
      className: "".concat(ae, "-item-remove"),
      onMouseDown: In,
      onClick: re,
      customizeIcon: w
    }, "×"));
  }, Te = function(O, L, h, ce, re, me) {
    var be = function(Ke) {
      In(Ke), M(!a);
    };
    return /* @__PURE__ */ r.createElement("span", {
      onMouseDown: be
    }, D({
      label: L,
      value: O,
      disabled: h,
      closable: ce,
      onClose: re,
      isMaxTag: !!me
    }));
  }, We = function(O) {
    var L = O.disabled, h = O.label, ce = O.value, re = !d && !L, me = h;
    if (typeof F == "number" && (typeof h == "string" || typeof h == "number")) {
      var be = String(me);
      be.length > F && (me = "".concat(be.slice(0, F), "..."));
    }
    var Me = function(ze) {
      ze && ze.stopPropagation(), X(O);
    };
    return typeof D == "function" ? Te(ce, me, L, re, Me) : le(O, me, L, re, Me);
  }, _ = function(O) {
    var L = typeof W == "function" ? W(O) : W;
    return typeof D == "function" ? Te(void 0, L, !1, !1, void 0, !0) : le({
      title: L
    }, L, !1);
  }, y = /* @__PURE__ */ r.createElement("div", {
    className: "".concat(ae, "-search"),
    style: {
      width: C
    },
    onFocus: function() {
      se(!0);
    },
    onBlur: function() {
      se(!1);
    }
  }, /* @__PURE__ */ r.createElement(cn, {
    ref: u,
    open: a,
    prefixCls: o,
    id: n,
    inputElement: null,
    disabled: d,
    autoFocus: c,
    autoComplete: b,
    editable: Fe,
    activeDescendantId: v,
    value: ue,
    onKeyDown: J,
    onMouseDown: G,
    onChange: Z,
    onPaste: H,
    onCompositionStart: ee,
    onCompositionEnd: I,
    tabIndex: f,
    attrs: Ht(t, !0)
  }), /* @__PURE__ */ r.createElement("span", {
    ref: N,
    className: "".concat(ae, "-search-mirror"),
    "aria-hidden": !0
  }, ue, " ")), x = /* @__PURE__ */ r.createElement(xo, {
    prefixCls: "".concat(ae, "-overflow"),
    data: i,
    renderItem: We,
    renderRest: _,
    suffix: y,
    itemKey: mi,
    maxCount: p
  });
  return /* @__PURE__ */ r.createElement(r.Fragment, null, x, !i.length && !ue && /* @__PURE__ */ r.createElement("span", {
    className: "".concat(ae, "-placeholder")
  }, g));
}, gi = function(t) {
  var n = t.inputElement, o = t.prefixCls, i = t.id, a = t.inputRef, l = t.disabled, s = t.autoFocus, u = t.autoComplete, g = t.activeDescendantId, d = t.mode, m = t.open, $ = t.values, c = t.placeholder, b = t.tabIndex, v = t.showSearch, f = t.searchValue, w = t.activeValue, p = t.maxLength, F = t.onInputKeyDown, z = t.onInputMouseDown, W = t.onInputChange, D = t.onInputPaste, M = t.onInputCompositionStart, X = t.onInputCompositionEnd, Z = t.title, H = r.useState(!1), J = fe(H, 2), G = J[0], ee = J[1], I = d === "combobox", N = I || v, te = $[0], A = f || "";
  I && w && !G && (A = w), r.useEffect(function() {
    I && ee(!1);
  }, [I, w]);
  var C = d !== "combobox" && !m && !v ? !1 : !!A, K = Z === void 0 ? Wn(te) : Z, Q = r.useMemo(function() {
    return te ? null : /* @__PURE__ */ r.createElement("span", {
      className: "".concat(o, "-selection-placeholder"),
      style: C ? {
        visibility: "hidden"
      } : void 0
    }, c);
  }, [te, C, c, o]);
  return /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement("span", {
    className: "".concat(o, "-selection-search")
  }, /* @__PURE__ */ r.createElement(cn, {
    ref: a,
    prefixCls: o,
    id: i,
    open: m,
    inputElement: n,
    disabled: l,
    autoFocus: s,
    autoComplete: u,
    editable: N,
    activeDescendantId: g,
    value: A,
    onKeyDown: F,
    onMouseDown: z,
    onChange: function(Re) {
      ee(!0), W(Re);
    },
    onPaste: D,
    onCompositionStart: M,
    onCompositionEnd: X,
    tabIndex: b,
    attrs: Ht(t, !0),
    maxLength: I ? p : void 0
  })), !I && te ? /* @__PURE__ */ r.createElement("span", {
    className: "".concat(o, "-selection-item"),
    title: K,
    style: C ? {
      visibility: "hidden"
    } : void 0
  }, te.label) : null, Q);
}, pi = function(t, n) {
  var o = Yt(null), i = Yt(!1), a = t.prefixCls, l = t.open, s = t.mode, u = t.showSearch, g = t.tokenWithEnter, d = t.disabled, m = t.autoClearSearchValue, $ = t.onSearch, c = t.onSearchSubmit, b = t.onToggleOpen, v = t.onInputKeyDown, f = t.domRef;
  r.useImperativeHandle(n, function() {
    return {
      focus: function(C) {
        o.current.focus(C);
      },
      blur: function() {
        o.current.blur();
      }
    };
  });
  var w = Fn(0), p = fe(w, 2), F = p[0], z = p[1], W = function(C) {
    var K = C.which;
    (K === T.UP || K === T.DOWN) && C.preventDefault(), v && v(C), K === T.ENTER && s === "tags" && !i.current && !l && (c == null || c(C.target.value)), ri(K) && b(!0);
  }, D = function() {
    z(!0);
  }, M = Yt(null), X = function(C) {
    $(C, !0, i.current) !== !1 && b(!0);
  }, Z = function() {
    i.current = !0;
  }, H = function(C) {
    i.current = !1, s !== "combobox" && X(C.target.value);
  }, J = function(C) {
    var K = C.target.value;
    if (g && M.current && /[\r\n]/.test(M.current)) {
      var Q = M.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      K = K.replace(Q, M.current);
    }
    M.current = null, X(K);
  }, G = function(C) {
    var K = C.clipboardData, Q = K == null ? void 0 : K.getData("text");
    M.current = Q || "";
  }, ee = function(C) {
    var K = C.target;
    if (K !== o.current) {
      var Q = document.body.style.msTouchAction !== void 0;
      Q ? setTimeout(function() {
        o.current.focus();
      }) : o.current.focus();
    }
  }, I = function(C) {
    var K = F();
    C.target !== o.current && !K && !(s === "combobox" && d) && C.preventDefault(), (s !== "combobox" && (!u || !K) || !l) && (l && m !== !1 && $("", !0, !1), b());
  }, N = {
    inputRef: o,
    onInputKeyDown: W,
    onInputMouseDown: D,
    onInputChange: J,
    onInputPaste: G,
    onInputCompositionStart: Z,
    onInputCompositionEnd: H
  }, te = s === "multiple" || s === "tags" ? /* @__PURE__ */ r.createElement(fi, Ee({}, t, N)) : /* @__PURE__ */ r.createElement(gi, Ee({}, t, N));
  return /* @__PURE__ */ r.createElement("div", {
    ref: f,
    className: "".concat(a, "-selector"),
    onClick: ee,
    onMouseDown: I
  }, te);
}, Kn = /* @__PURE__ */ r.forwardRef(pi);
process.env.NODE_ENV !== "production" && (Kn.displayName = "Selector");
var vi = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], hi = function(t) {
  var n = t === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, bi = function(t, n) {
  var o = t.prefixCls;
  t.disabled;
  var i = t.visible, a = t.children, l = t.popupElement, s = t.animation, u = t.transitionName, g = t.dropdownStyle, d = t.dropdownClassName, m = t.direction, $ = m === void 0 ? "ltr" : m, c = t.placement, b = t.builtinPlacements, v = t.dropdownMatchSelectWidth, f = t.dropdownRender, w = t.dropdownAlign, p = t.getPopupContainer, F = t.empty, z = t.getTriggerDOMNode, W = t.onPopupVisibleChange, D = t.onPopupMouseEnter, M = _t(t, vi), X = "".concat(o, "-dropdown"), Z = l;
  f && (Z = f(l));
  var H = r.useMemo(function() {
    return b || hi(v);
  }, [b, v]), J = s ? "".concat(X, "-").concat(s) : u, G = typeof v == "number", ee = r.useMemo(function() {
    return G ? null : v === !1 ? "minWidth" : "width";
  }, [v, G]), I = g;
  G && (I = ve(ve({}, I), {}, {
    width: v
  }));
  var N = r.useRef(null);
  return r.useImperativeHandle(n, function() {
    return {
      getPopupElement: function() {
        var A;
        return (A = N.current) === null || A === void 0 ? void 0 : A.popupElement;
      }
    };
  }), /* @__PURE__ */ r.createElement(_o, Ee({}, M, {
    showAction: W ? ["click"] : [],
    hideAction: W ? ["click"] : [],
    popupPlacement: c || ($ === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: H,
    prefixCls: X,
    popupTransitionName: J,
    popup: /* @__PURE__ */ r.createElement("div", {
      onMouseEnter: D
    }, Z),
    ref: N,
    stretch: ee,
    popupAlign: w,
    popupVisible: i,
    getPopupContainer: p,
    popupClassName: xe(d, ie({}, "".concat(X, "-empty"), F)),
    popupStyle: I,
    getTriggerDOMNode: z,
    onPopupVisibleChange: W
  }), a);
}, Un = /* @__PURE__ */ r.forwardRef(bi);
process.env.NODE_ENV !== "production" && (Un.displayName = "SelectTrigger");
function xn(e, t) {
  var n = e.key, o;
  return "value" in e && (o = e.value), n ?? (o !== void 0 ? o : "rc-index-key-".concat(t));
}
function rn(e) {
  return typeof e < "u" && !Number.isNaN(e);
}
function Xn(e, t) {
  var n = e || {}, o = n.label, i = n.value, a = n.options, l = n.groupLabel, s = o || (t ? "children" : "label");
  return {
    label: s,
    value: i || "value",
    options: a || "options",
    groupLabel: l || s
  };
}
function Si(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.fieldNames, o = t.childrenAsData, i = [], a = Xn(n, !1), l = a.label, s = a.value, u = a.options, g = a.groupLabel;
  function d(m, $) {
    Array.isArray(m) && m.forEach(function(c) {
      if ($ || !(u in c)) {
        var b = c[s];
        i.push({
          key: xn(c, i.length),
          groupOption: $,
          data: c,
          label: c[l],
          value: b
        });
      } else {
        var v = c[g];
        v === void 0 && o && (v = c.label), i.push({
          key: xn(c, i.length),
          group: !0,
          data: c,
          label: v
        }), d(c[u], !0);
      }
    });
  }
  return d(e, !1), i;
}
function an(e) {
  var t = ve({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get: function() {
      return Le(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), t;
    }
  }), t;
}
var Ci = function(t, n, o) {
  if (!n || !n.length)
    return null;
  var i = !1, a = function s(u, g) {
    var d = vo(g), m = d[0], $ = d.slice(1);
    if (!m)
      return [u];
    var c = u.split(m);
    return i = i || c.length > 1, c.reduce(function(b, v) {
      return [].concat(Qe(b), Qe(s(v, $)));
    }, []).filter(Boolean);
  }, l = a(t, n);
  return i ? typeof o < "u" ? l.slice(0, o) : l : null;
}, un = /* @__PURE__ */ r.createContext(null);
function yi(e) {
  var t = e.visible, n = e.values;
  if (!t)
    return null;
  var o = 50;
  return /* @__PURE__ */ r.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(n.slice(0, o).map(function(i) {
    var a = i.label, l = i.value;
    return ["number", "string"].includes(zt(a)) ? a : l;
  }).join(", ")), n.length > o ? ", ..." : null);
}
var wi = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], $i = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], Wt = function(t) {
  return t === "tags" || t === "multiple";
}, Gn = /* @__PURE__ */ r.forwardRef(function(e, t) {
  var n, o = e.id, i = e.prefixCls, a = e.className, l = e.showSearch, s = e.tagRender, u = e.direction, g = e.omitDomProps, d = e.displayValues, m = e.onDisplayValuesChange, $ = e.emptyOptions, c = e.notFoundContent, b = c === void 0 ? "Not Found" : c, v = e.onClear, f = e.mode, w = e.disabled, p = e.loading, F = e.getInputElement, z = e.getRawInputElement, W = e.open, D = e.defaultOpen, M = e.onDropdownVisibleChange, X = e.activeValue, Z = e.onActiveValueChange, H = e.activeDescendantId, J = e.searchValue, G = e.autoClearSearchValue, ee = e.onSearch, I = e.onSearchSplit, N = e.tokenSeparators, te = e.allowClear, A = e.suffixIcon, C = e.clearIcon, K = e.OptionList, Q = e.animation, Oe = e.transitionName, Re = e.dropdownStyle, se = e.dropdownClassName, ae = e.dropdownMatchSelectWidth, ue = e.dropdownRender, Fe = e.dropdownAlign, le = e.placement, Te = e.builtinPlacements, We = e.getPopupContainer, _ = e.showAction, y = _ === void 0 ? [] : _, x = e.onFocus, q = e.onBlur, O = e.onKeyUp, L = e.onKeyDown, h = e.onMouseDown, ce = _t(e, wi), re = Wt(f), me = (l !== void 0 ? l : re) || f === "combobox", be = ve({}, ce);
  $i.forEach(function(ne) {
    delete be[ne];
  }), g == null || g.forEach(function(ne) {
    delete be[ne];
  });
  var Me = r.useState(!1), Ke = fe(Me, 2), ze = Ke[0], ge = Ke[1];
  r.useEffect(function() {
    ge(To());
  }, []);
  var Ue = r.useRef(null), Se = r.useRef(null), Ie = r.useRef(null), Ce = r.useRef(null), Je = r.useRef(null), Ne = r.useRef(!1), Xe = oi(), Be = fe(Xe, 3), Ve = Be[0], de = Be[1], et = Be[2];
  r.useImperativeHandle(t, function() {
    var ne, U;
    return {
      focus: (ne = Ce.current) === null || ne === void 0 ? void 0 : ne.focus,
      blur: (U = Ce.current) === null || U === void 0 ? void 0 : U.blur,
      scrollTo: function(Ae) {
        var $e;
        return ($e = Je.current) === null || $e === void 0 ? void 0 : $e.scrollTo(Ae);
      },
      nativeElement: Ue.current || Se.current
    };
  });
  var Pe = r.useMemo(function() {
    var ne;
    if (f !== "combobox")
      return J;
    var U = (ne = d[0]) === null || ne === void 0 ? void 0 : ne.value;
    return typeof U == "string" || typeof U == "number" ? String(U) : "";
  }, [J, f, d]), De = f === "combobox" && typeof F == "function" && F() || null, we = typeof z == "function" && z(), wt = ho(Se, we == null || (n = we.props) === null || n === void 0 ? void 0 : n.ref), pt = r.useState(!1), vt = fe(pt, 2), it = vt[0], $t = vt[1];
  bo(function() {
    $t(!0);
  }, []);
  var It = jt(!1, {
    defaultValue: D,
    value: W
  }), rt = fe(It, 2), ht = rt[0], bt = rt[1], ye = it ? ht : !1, at = !b && $;
  (w || at && ye && f === "combobox") && (ye = !1);
  var lt = at ? !1 : ye, E = r.useCallback(function(ne) {
    var U = ne !== void 0 ? ne : !ye;
    w || (bt(U), ye !== U && (M == null || M(U)));
  }, [w, ye, bt, M]), V = r.useMemo(function() {
    return (N || []).some(function(ne) {
      return [`
`, `\r
`].includes(ne);
    });
  }, [N]), P = r.useContext(un) || {}, S = P.maxCount, B = P.rawValues, oe = function(U, He, Ae) {
    if (!(re && rn(S) && (B == null ? void 0 : B.size) >= S)) {
      var $e = !0, _e = U;
      Z == null || Z(null);
      var ot = Ci(U, N, rn(S) ? S - B.size : void 0), mt = Ae ? null : ot;
      return f !== "combobox" && mt && (_e = "", I == null || I(mt), E(!1), $e = !1), ee && Pe !== _e && ee(_e, {
        source: He ? "typing" : "effect"
      }), $e;
    }
  }, Ze = function(U) {
    !U || !U.trim() || ee(U, {
      source: "submit"
    });
  };
  r.useEffect(function() {
    !ye && !re && f !== "combobox" && oe("", !1, !1);
  }, [ye]), r.useEffect(function() {
    ht && w && bt(!1), w && !Ne.current && de(!1);
  }, [w]);
  var Ye = Fn(), Ge = fe(Ye, 2), he = Ge[0], je = Ge[1], tt = function(U) {
    var He = he(), Ae = U.which;
    if (Ae === T.ENTER && (f !== "combobox" && U.preventDefault(), ye || E(!0)), je(!!Pe), Ae === T.BACKSPACE && !He && re && !Pe && d.length) {
      for (var $e = Qe(d), _e = null, ot = $e.length - 1; ot >= 0; ot -= 1) {
        var mt = $e[ot];
        if (!mt.disabled) {
          $e.splice(ot, 1), _e = mt;
          break;
        }
      }
      _e && m($e, {
        type: "remove",
        values: [_e]
      });
    }
    for (var ft = arguments.length, Dt = new Array(ft > 1 ? ft - 1 : 0), gt = 1; gt < ft; gt++)
      Dt[gt - 1] = arguments[gt];
    if (ye) {
      var Ft;
      (Ft = Je.current) === null || Ft === void 0 || Ft.onKeyDown.apply(Ft, [U].concat(Dt));
    }
    L == null || L.apply(void 0, [U].concat(Dt));
  }, qe = function(U) {
    for (var He = arguments.length, Ae = new Array(He > 1 ? He - 1 : 0), $e = 1; $e < He; $e++)
      Ae[$e - 1] = arguments[$e];
    if (ye) {
      var _e;
      (_e = Je.current) === null || _e === void 0 || _e.onKeyUp.apply(_e, [U].concat(Ae));
    }
    O == null || O.apply(void 0, [U].concat(Ae));
  }, ut = function(U) {
    var He = d.filter(function(Ae) {
      return Ae !== U;
    });
    m(He, {
      type: "remove",
      values: [U]
    });
  }, ct = r.useRef(!1), ke = function() {
    de(!0), w || (x && !ct.current && x.apply(void 0, arguments), y.includes("focus") && E(!0)), ct.current = !0;
  }, At = function() {
    Ne.current = !0, de(!1, function() {
      ct.current = !1, Ne.current = !1, E(!1);
    }), !w && (Pe && (f === "tags" ? ee(Pe, {
      source: "submit"
    }) : f === "multiple" && ee("", {
      source: "blur"
    })), q && q.apply(void 0, arguments));
  }, st = [];
  r.useEffect(function() {
    return function() {
      st.forEach(function(ne) {
        return clearTimeout(ne);
      }), st.splice(0, st.length);
    };
  }, []);
  var Tt = function(U) {
    var He, Ae = U.target, $e = (He = Ie.current) === null || He === void 0 ? void 0 : He.getPopupElement();
    if ($e && $e.contains(Ae)) {
      var _e = setTimeout(function() {
        var Dt = st.indexOf(_e);
        if (Dt !== -1 && st.splice(Dt, 1), et(), !ze && !$e.contains(document.activeElement)) {
          var gt;
          (gt = Ce.current) === null || gt === void 0 || gt.focus();
        }
      });
      st.push(_e);
    }
    for (var ot = arguments.length, mt = new Array(ot > 1 ? ot - 1 : 0), ft = 1; ft < ot; ft++)
      mt[ft - 1] = arguments[ft];
    h == null || h.apply(void 0, [U].concat(mt));
  }, Bt = r.useState({}), St = fe(Bt, 2), Lt = St[1];
  function xt() {
    Lt({});
  }
  var Et;
  we && (Et = function(U) {
    E(U);
  }), ii(function() {
    var ne;
    return [Ue.current, (ne = Ie.current) === null || ne === void 0 ? void 0 : ne.getPopupElement()];
  }, lt, E, !!we);
  var Ot = r.useMemo(function() {
    return ve(ve({}, e), {}, {
      notFoundContent: b,
      open: ye,
      triggerOpen: lt,
      id: o,
      showSearch: me,
      multiple: re,
      toggleOpen: E
    });
  }, [e, b, lt, ye, o, me, re, E]), dt = !!A || p, Nt;
  dt && (Nt = /* @__PURE__ */ r.createElement(Xt, {
    className: xe("".concat(i, "-arrow"), ie({}, "".concat(i, "-arrow-loading"), p)),
    customizeIcon: A,
    customizeIconProps: {
      loading: p,
      searchValue: Pe,
      open: ye,
      focused: Ve,
      showSearch: me
    }
  }));
  var qt = function() {
    var U;
    v == null || v(), (U = Ce.current) === null || U === void 0 || U.focus(), m([], {
      type: "clear",
      values: d
    }), oe("", !1, !1);
  }, R = ti(i, qt, d, te, C, w, Pe, f), k = R.allowClear, pe = R.clearIcon, nt = /* @__PURE__ */ r.createElement(K, {
    ref: Je
  }), Pt = xe(i, a, ie(ie(ie(ie(ie(ie(ie(ie(ie(ie({}, "".concat(i, "-focused"), Ve), "".concat(i, "-multiple"), re), "".concat(i, "-single"), !re), "".concat(i, "-allow-clear"), te), "".concat(i, "-show-arrow"), dt), "".concat(i, "-disabled"), w), "".concat(i, "-loading"), p), "".concat(i, "-open"), ye), "".concat(i, "-customize-input"), De), "".concat(i, "-show-search"), me)), pn = /* @__PURE__ */ r.createElement(Un, {
    ref: Ie,
    disabled: w,
    prefixCls: i,
    visible: lt,
    popupElement: nt,
    animation: Q,
    transitionName: Oe,
    dropdownStyle: Re,
    dropdownClassName: se,
    direction: u,
    dropdownMatchSelectWidth: ae,
    dropdownRender: ue,
    dropdownAlign: Fe,
    placement: le,
    builtinPlacements: Te,
    getPopupContainer: We,
    empty: $,
    getTriggerDOMNode: function(U) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        Se.current || U
      );
    },
    onPopupVisibleChange: Et,
    onPopupMouseEnter: xt
  }, we ? /* @__PURE__ */ r.cloneElement(we, {
    ref: wt
  }) : /* @__PURE__ */ r.createElement(Kn, Ee({}, e, {
    domRef: Se,
    prefixCls: i,
    inputElement: De,
    ref: Ce,
    id: o,
    showSearch: me,
    autoClearSearchValue: G,
    mode: f,
    activeDescendantId: H,
    tagRender: s,
    values: d,
    open: ye,
    onToggleOpen: E,
    activeValue: X,
    searchValue: Pe,
    onSearch: oe,
    onSearchSubmit: Ze,
    onRemove: ut,
    tokenWithEnter: V
  }))), Jt;
  return we ? Jt = pn : Jt = /* @__PURE__ */ r.createElement("div", Ee({
    className: Pt
  }, be, {
    ref: Ue,
    onMouseDown: Tt,
    onKeyDown: tt,
    onKeyUp: qe,
    onFocus: ke,
    onBlur: At
  }), /* @__PURE__ */ r.createElement(yi, {
    visible: Ve && !ye,
    values: d
  }), pn, Nt, k && pe), /* @__PURE__ */ r.createElement(Ln.Provider, {
    value: Ot
  }, Jt);
});
process.env.NODE_ENV !== "production" && (Gn.displayName = "BaseSelect");
var dn = function() {
  return null;
};
dn.isSelectOptGroup = !0;
var mn = function() {
  return null;
};
mn.isSelectOption = !0;
function Ii() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var xi = ["disabled", "title", "children", "style", "className"];
function En(e) {
  return typeof e == "string" || typeof e == "number";
}
var Ei = function(t, n) {
  var o = ni(), i = o.prefixCls, a = o.id, l = o.open, s = o.multiple, u = o.mode, g = o.searchValue, d = o.toggleOpen, m = o.notFoundContent, $ = o.onPopupScroll, c = r.useContext(un), b = c.maxCount, v = c.flattenOptions, f = c.onActiveValue, w = c.defaultActiveFirstOption, p = c.onSelect, F = c.menuItemSelectedIcon, z = c.rawValues, W = c.fieldNames, D = c.virtual, M = c.direction, X = c.listHeight, Z = c.listItemHeight, H = c.optionRender, J = "".concat(i, "-item"), G = So(function() {
    return v;
  }, [l, v], function(_, y) {
    return y[0] && _[1] !== y[1];
  }), ee = r.useRef(null), I = r.useMemo(function() {
    return s && rn(b) && (z == null ? void 0 : z.size) >= b;
  }, [s, b, z == null ? void 0 : z.size]), N = function(y) {
    y.preventDefault();
  }, te = function(y) {
    var x;
    (x = ee.current) === null || x === void 0 || x.scrollTo(typeof y == "number" ? {
      index: y
    } : y);
  }, A = function(y) {
    for (var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, q = G.length, O = 0; O < q; O += 1) {
      var L = (y + O * x + q) % q, h = G[L] || {}, ce = h.group, re = h.data;
      if (!ce && !(re != null && re.disabled) && !I)
        return L;
    }
    return -1;
  }, C = r.useState(function() {
    return A(0);
  }), K = fe(C, 2), Q = K[0], Oe = K[1], Re = function(y) {
    var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    Oe(y);
    var q = {
      source: x ? "keyboard" : "mouse"
    }, O = G[y];
    if (!O) {
      f(null, -1, q);
      return;
    }
    f(O.value, y, q);
  };
  tn(function() {
    Re(w !== !1 ? A(0) : -1);
  }, [G.length, g]);
  var se = r.useCallback(function(_) {
    return z.has(_) && u !== "combobox";
  }, [u, Qe(z).toString(), z.size]);
  tn(function() {
    var _ = setTimeout(function() {
      if (!s && l && z.size === 1) {
        var x = Array.from(z)[0], q = G.findIndex(function(O) {
          var L = O.data;
          return L.value === x;
        });
        q !== -1 && (Re(q), te(q));
      }
    });
    if (l) {
      var y;
      (y = ee.current) === null || y === void 0 || y.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(_);
    };
  }, [l, g]);
  var ae = function(y) {
    y !== void 0 && p(y, {
      selected: !z.has(y)
    }), s || d(!1);
  };
  if (r.useImperativeHandle(n, function() {
    return {
      onKeyDown: function(y) {
        var x = y.which, q = y.ctrlKey;
        switch (x) {
          case T.N:
          case T.P:
          case T.UP:
          case T.DOWN: {
            var O = 0;
            if (x === T.UP ? O = -1 : x === T.DOWN ? O = 1 : Ii() && q && (x === T.N ? O = 1 : x === T.P && (O = -1)), O !== 0) {
              var L = A(Q + O, O);
              te(L), Re(L, !0);
            }
            break;
          }
          case T.ENTER: {
            var h, ce = G[Q];
            ce && !(ce != null && (h = ce.data) !== null && h !== void 0 && h.disabled) && !I ? ae(ce.value) : ae(void 0), l && y.preventDefault();
            break;
          }
          case T.ESC:
            d(!1), l && y.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(y) {
        te(y);
      }
    };
  }), G.length === 0)
    return /* @__PURE__ */ r.createElement("div", {
      role: "listbox",
      id: "".concat(a, "_list"),
      className: "".concat(J, "-empty"),
      onMouseDown: N
    }, m);
  var ue = Object.keys(W).map(function(_) {
    return W[_];
  }), Fe = function(y) {
    return y.label;
  };
  function le(_, y) {
    var x = _.group;
    return {
      role: x ? "presentation" : "option",
      id: "".concat(a, "_list_").concat(y)
    };
  }
  var Te = function(y) {
    var x = G[y];
    if (!x)
      return null;
    var q = x.data || {}, O = q.value, L = x.group, h = Ht(q, !0), ce = Fe(x);
    return x ? /* @__PURE__ */ r.createElement("div", Ee({
      "aria-label": typeof ce == "string" && !L ? ce : null
    }, h, {
      key: y
    }, le(x, y), {
      "aria-selected": se(O)
    }), O) : null;
  }, We = {
    role: "listbox",
    id: "".concat(a, "_list")
  };
  return /* @__PURE__ */ r.createElement(r.Fragment, null, D && /* @__PURE__ */ r.createElement("div", Ee({}, We, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), Te(Q - 1), Te(Q), Te(Q + 1)), /* @__PURE__ */ r.createElement(Bo, {
    itemKey: "key",
    ref: ee,
    data: G,
    height: X,
    itemHeight: Z,
    fullHeight: !1,
    onMouseDown: N,
    onScroll: $,
    virtual: D,
    direction: M,
    innerProps: D ? null : We
  }, function(_, y) {
    var x = _.group, q = _.groupOption, O = _.data, L = _.label, h = _.value, ce = O.key;
    if (x) {
      var re, me = (re = O.title) !== null && re !== void 0 ? re : En(L) ? L.toString() : void 0;
      return /* @__PURE__ */ r.createElement("div", {
        className: xe(J, "".concat(J, "-group"), O.className),
        title: me
      }, L !== void 0 ? L : ce);
    }
    var be = O.disabled, Me = O.title;
    O.children;
    var Ke = O.style, ze = O.className, ge = _t(O, xi), Ue = An(ge, ue), Se = se(h), Ie = be || !Se && I, Ce = "".concat(J, "-option"), Je = xe(J, Ce, ze, ie(ie(ie(ie({}, "".concat(Ce, "-grouped"), q), "".concat(Ce, "-active"), Q === y && !Ie), "".concat(Ce, "-disabled"), Ie), "".concat(Ce, "-selected"), Se)), Ne = Fe(_), Xe = !F || typeof F == "function" || Se, Be = typeof Ne == "number" ? Ne : Ne || h, Ve = En(Be) ? Be.toString() : void 0;
    return Me !== void 0 && (Ve = Me), /* @__PURE__ */ r.createElement("div", Ee({}, Ht(Ue), D ? {} : le(_, y), {
      "aria-selected": Se,
      className: Je,
      title: Ve,
      onMouseMove: function() {
        Q === y || Ie || Re(y);
      },
      onClick: function() {
        Ie || ae(h);
      },
      style: Ke
    }), /* @__PURE__ */ r.createElement("div", {
      className: "".concat(Ce, "-content")
    }, typeof H == "function" ? H(_, {
      index: y
    }) : Be), /* @__PURE__ */ r.isValidElement(F) || Se, Xe && /* @__PURE__ */ r.createElement(Xt, {
      className: "".concat(J, "-option-state"),
      customizeIcon: F,
      customizeIconProps: {
        value: h,
        disabled: Ie,
        isSelected: Se
      }
    }, Se ? "✓" : null));
  }));
}, qn = /* @__PURE__ */ r.forwardRef(Ei);
process.env.NODE_ENV !== "production" && (qn.displayName = "OptionList");
const Oi = function(e, t) {
  var n = r.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), o = r.useMemo(function() {
    var a = n.current, l = a.values, s = a.options, u = e.map(function(m) {
      if (m.label === void 0) {
        var $;
        return ve(ve({}, m), {}, {
          label: ($ = l.get(m.value)) === null || $ === void 0 ? void 0 : $.label
        });
      }
      return m;
    }), g = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map();
    return u.forEach(function(m) {
      g.set(m.value, m), d.set(m.value, t.get(m.value) || s.get(m.value));
    }), n.current.values = g, n.current.options = d, u;
  }, [e, t]), i = r.useCallback(function(a) {
    return t.get(a) || n.current.options.get(a);
  }, [t]);
  return [o, i];
};
function Qt(e, t) {
  return sn(e).join("").toUpperCase().includes(t);
}
const Ni = function(e, t, n, o, i) {
  return r.useMemo(function() {
    if (!n || o === !1)
      return e;
    var a = t.options, l = t.label, s = t.value, u = [], g = typeof o == "function", d = n.toUpperCase(), m = g ? o : function(c, b) {
      return i ? Qt(b[i], d) : b[a] ? Qt(b[l !== "children" ? l : "label"], d) : Qt(b[s], d);
    }, $ = g ? function(c) {
      return an(c);
    } : function(c) {
      return c;
    };
    return e.forEach(function(c) {
      if (c[a]) {
        var b = m(n, $(c));
        if (b)
          u.push(c);
        else {
          var v = c[a].filter(function(f) {
            return m(n, $(f));
          });
          v.length && u.push(ve(ve({}, c), {}, ie({}, a, v)));
        }
        return;
      }
      m(n, $(c)) && u.push(c);
    }), u;
  }, [e, o, i, n, t]);
};
var On = 0, Pi = process.env.NODE_ENV !== "test" && Co();
function Di() {
  var e;
  return Pi ? (e = On, On += 1) : e = "TEST_OR_SSR", e;
}
function Mi(e) {
  var t = r.useState(), n = fe(t, 2), o = n[0], i = n[1];
  return r.useEffect(function() {
    i("rc_select_".concat(Di()));
  }, []), e || o;
}
var Ri = ["children", "value"], zi = ["children"];
function _i(e) {
  var t = e, n = t.key, o = t.props, i = o.children, a = o.value, l = _t(o, Ri);
  return ve({
    key: n,
    value: a !== void 0 ? a : n,
    children: i
  }, l);
}
function fn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return on(e).map(function(n, o) {
    if (!/* @__PURE__ */ r.isValidElement(n) || !n.type)
      return null;
    var i = n, a = i.type.isSelectOptGroup, l = i.key, s = i.props, u = s.children, g = _t(s, zi);
    return t || !a ? _i(n) : ve(ve({
      key: "__RC_SELECT_GRP__".concat(l === null ? o : l, "__"),
      label: l
    }, g), {}, {
      options: fn(u)
    });
  }).filter(function(n) {
    return n;
  });
}
var Ti = function(t, n, o, i, a) {
  return r.useMemo(function() {
    var l = t, s = !t;
    s && (l = fn(n));
    var u = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Map(), d = function(c, b, v) {
      v && typeof v == "string" && c.set(b[v], b);
    }, m = function $(c) {
      for (var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, v = 0; v < c.length; v += 1) {
        var f = c[v];
        !f[o.options] || b ? (u.set(f[o.value], f), d(g, f, o.label), d(g, f, i), d(g, f, a)) : $(f[o.options], !0);
      }
    };
    return m(l), {
      options: l,
      valueOptions: u,
      labelOptions: g
    };
  }, [t, n, o, i, a]);
};
function Nn(e) {
  var t = r.useRef();
  t.current = e;
  var n = r.useCallback(function() {
    return t.current.apply(t, arguments);
  }, []);
  return n;
}
function Bi(e) {
  var t = e.mode, n = e.options, o = e.children, i = e.backfill, a = e.allowClear, l = e.placeholder, s = e.getInputElement, u = e.showSearch, g = e.onSearch, d = e.defaultOpen, m = e.autoFocus, $ = e.labelInValue, c = e.value, b = e.inputValue, v = e.optionLabelProp, f = Wt(t), w = u !== void 0 ? u : f || t === "combobox", p = n || fn(o);
  if (Le(t !== "tags" || p.every(function(D) {
    return !D.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), t === "tags" || t === "combobox") {
    var F = p.some(function(D) {
      return D.options ? D.options.some(function(M) {
        return typeof ("value" in M ? M.value : M.key) == "number";
      }) : typeof ("value" in D ? D.value : D.key) == "number";
    });
    Le(!F, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (Le(t !== "combobox" || !v, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), Le(t === "combobox" || !i, "`backfill` only works with `combobox` mode."), Le(t === "combobox" || !s, "`getInputElement` only work with `combobox` mode."), hn(t !== "combobox" || !s || !a || !l, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), g && !w && t !== "combobox" && t !== "tags" && Le(!1, "`onSearch` should work with `showSearch` instead of use alone."), hn(!d || m, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), c != null) {
    var z = sn(c);
    Le(!$ || z.every(function(D) {
      return zt(D) === "object" && ("key" in D || "value" in D);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), Le(!f || Array.isArray(c), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (o) {
    var W = null;
    on(o).some(function(D) {
      if (!/* @__PURE__ */ r.isValidElement(D) || !D.type)
        return !1;
      var M = D, X = M.type;
      if (X.isSelectOption)
        return !1;
      if (X.isSelectOptGroup) {
        var Z = on(D.props.children).every(function(H) {
          return !/* @__PURE__ */ r.isValidElement(H) || !D.type || H.type.isSelectOption ? !0 : (W = H.type, !1);
        });
        return !Z;
      }
      return W = X, !0;
    }), W && Le(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(W.displayName || W.name || W, "`.")), Le(b === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function Vi(e, t) {
  if (e) {
    var n = function o(i) {
      for (var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, l = 0; l < i.length; l++) {
        var s = i[l];
        if (s[t == null ? void 0 : t.value] === null)
          return Le(!1, "`value` in Select options should not be `null`."), !0;
        if (!a && Array.isArray(s[t == null ? void 0 : t.options]) && o(s[t == null ? void 0 : t.options], !0))
          break;
      }
    };
    n(e);
  }
}
var ji = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], Hi = ["inputValue"];
function Ai(e) {
  return !e || zt(e) !== "object";
}
var Jn = /* @__PURE__ */ r.forwardRef(function(e, t) {
  var n = e.id, o = e.mode, i = e.prefixCls, a = i === void 0 ? "rc-select" : i, l = e.backfill, s = e.fieldNames, u = e.inputValue, g = e.searchValue, d = e.onSearch, m = e.autoClearSearchValue, $ = m === void 0 ? !0 : m, c = e.onSelect, b = e.onDeselect, v = e.dropdownMatchSelectWidth, f = v === void 0 ? !0 : v, w = e.filterOption, p = e.filterSort, F = e.optionFilterProp, z = e.optionLabelProp, W = e.options, D = e.optionRender, M = e.children, X = e.defaultActiveFirstOption, Z = e.menuItemSelectedIcon, H = e.virtual, J = e.direction, G = e.listHeight, ee = G === void 0 ? 200 : G, I = e.listItemHeight, N = I === void 0 ? 20 : I, te = e.labelRender, A = e.value, C = e.defaultValue, K = e.labelInValue, Q = e.onChange, Oe = e.maxCount, Re = _t(e, ji), se = Mi(n), ae = Wt(o), ue = !!(!W && M), Fe = r.useMemo(function() {
    return w === void 0 && o === "combobox" ? !1 : w;
  }, [w, o]), le = r.useMemo(
    function() {
      return Xn(s, ue);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(s),
      ue
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), Te = jt("", {
    value: g !== void 0 ? g : u,
    postState: function(V) {
      return V || "";
    }
  }), We = fe(Te, 2), _ = We[0], y = We[1], x = Ti(W, M, le, F, z), q = x.valueOptions, O = x.labelOptions, L = x.options, h = r.useCallback(function(E) {
    var V = sn(E);
    return V.map(function(P) {
      var S, B, oe, Ze, Ye;
      if (Ai(P))
        S = P;
      else {
        var Ge;
        oe = P.key, B = P.label, S = (Ge = P.value) !== null && Ge !== void 0 ? Ge : oe;
      }
      var he = q.get(S);
      if (he) {
        var je;
        if (B === void 0 && (B = he == null ? void 0 : he[z || le.label]), oe === void 0 && (oe = (je = he == null ? void 0 : he.key) !== null && je !== void 0 ? je : S), Ze = he == null ? void 0 : he.disabled, Ye = he == null ? void 0 : he.title, process.env.NODE_ENV !== "production" && !z) {
          var tt = he == null ? void 0 : he[le.label];
          tt !== void 0 && !/* @__PURE__ */ r.isValidElement(tt) && !/* @__PURE__ */ r.isValidElement(B) && tt !== B && Le(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: B,
        value: S,
        key: oe,
        disabled: Ze,
        title: Ye
      };
    });
  }, [le, z, q]), ce = jt(C, {
    value: A
  }), re = fe(ce, 2), me = re[0], be = re[1], Me = r.useMemo(function() {
    var E, V = ae && me === null ? [] : me, P = h(V);
    return o === "combobox" && ui((E = P[0]) === null || E === void 0 ? void 0 : E.value) ? [] : P;
  }, [me, h, o, ae]), Ke = Oi(Me, q), ze = fe(Ke, 2), ge = ze[0], Ue = ze[1], Se = r.useMemo(function() {
    if (!o && ge.length === 1) {
      var E = ge[0];
      if (E.value === null && (E.label === null || E.label === void 0))
        return [];
    }
    return ge.map(function(V) {
      var P;
      return ve(ve({}, V), {}, {
        label: (P = typeof te == "function" ? te(V) : V.label) !== null && P !== void 0 ? P : V.value
      });
    });
  }, [o, ge, te]), Ie = r.useMemo(function() {
    return new Set(ge.map(function(E) {
      return E.value;
    }));
  }, [ge]);
  r.useEffect(function() {
    if (o === "combobox") {
      var E, V = (E = ge[0]) === null || E === void 0 ? void 0 : E.value;
      y(si(V) ? String(V) : "");
    }
  }, [ge]);
  var Ce = Nn(function(E, V) {
    var P = V ?? E;
    return ie(ie({}, le.value, E), le.label, P);
  }), Je = r.useMemo(function() {
    if (o !== "tags")
      return L;
    var E = Qe(L), V = function(S) {
      return q.has(S);
    };
    return Qe(ge).sort(function(P, S) {
      return P.value < S.value ? -1 : 1;
    }).forEach(function(P) {
      var S = P.value;
      V(S) || E.push(Ce(S, P.label));
    }), E;
  }, [Ce, L, q, ge, o]), Ne = Ni(Je, le, _, Fe, F), Xe = r.useMemo(function() {
    return o !== "tags" || !_ || Ne.some(function(E) {
      return E[F || "value"] === _;
    }) || Ne.some(function(E) {
      return E[le.value] === _;
    }) ? Ne : [Ce(_)].concat(Qe(Ne));
  }, [Ce, F, o, Ne, _, le]), Be = r.useMemo(function() {
    return p ? Qe(Xe).sort(function(E, V) {
      return p(E, V, {
        searchValue: _
      });
    }) : Xe;
  }, [Xe, p, _]), Ve = r.useMemo(function() {
    return Si(Be, {
      fieldNames: le,
      childrenAsData: ue
    });
  }, [Be, le, ue]), de = function(V) {
    var P = h(V);
    if (be(P), Q && // Trigger event only when value changed
    (P.length !== ge.length || P.some(function(oe, Ze) {
      var Ye;
      return ((Ye = ge[Ze]) === null || Ye === void 0 ? void 0 : Ye.value) !== (oe == null ? void 0 : oe.value);
    }))) {
      var S = K ? P : P.map(function(oe) {
        return oe.value;
      }), B = P.map(function(oe) {
        return an(Ue(oe.value));
      });
      Q(
        // Value
        ae ? S : S[0],
        // Option
        ae ? B : B[0]
      );
    }
  }, et = r.useState(null), Pe = fe(et, 2), De = Pe[0], we = Pe[1], wt = r.useState(0), pt = fe(wt, 2), vt = pt[0], it = pt[1], $t = X !== void 0 ? X : o !== "combobox", It = r.useCallback(function(E, V) {
    var P = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, S = P.source, B = S === void 0 ? "keyboard" : S;
    it(V), l && o === "combobox" && E !== null && B === "keyboard" && we(String(E));
  }, [l, o]), rt = function(V, P, S) {
    var B = function() {
      var ct, ke = Ue(V);
      return [K ? {
        label: ke == null ? void 0 : ke[le.label],
        value: V,
        key: (ct = ke == null ? void 0 : ke.key) !== null && ct !== void 0 ? ct : V
      } : V, an(ke)];
    };
    if (P && c) {
      var oe = B(), Ze = fe(oe, 2), Ye = Ze[0], Ge = Ze[1];
      c(Ye, Ge);
    } else if (!P && b && S !== "clear") {
      var he = B(), je = fe(he, 2), tt = je[0], qe = je[1];
      b(tt, qe);
    }
  }, ht = Nn(function(E, V) {
    var P, S = ae ? V.selected : !0;
    S ? P = ae ? [].concat(Qe(ge), [E]) : [E] : P = ge.filter(function(B) {
      return B.value !== E;
    }), de(P), rt(E, S), o === "combobox" ? we("") : (!Wt || $) && (y(""), we(""));
  }), bt = function(V, P) {
    de(V);
    var S = P.type, B = P.values;
    (S === "remove" || S === "clear") && B.forEach(function(oe) {
      rt(oe.value, !1, S);
    });
  }, ye = function(V, P) {
    if (y(V), we(null), P.source === "submit") {
      var S = (V || "").trim();
      if (S) {
        var B = Array.from(new Set([].concat(Qe(Ie), [S])));
        de(B), rt(S, !0), y("");
      }
      return;
    }
    P.source !== "blur" && (o === "combobox" && de(V), d == null || d(V));
  }, at = function(V) {
    var P = V;
    o !== "tags" && (P = V.map(function(B) {
      var oe = O.get(B);
      return oe == null ? void 0 : oe.value;
    }).filter(function(B) {
      return B !== void 0;
    }));
    var S = Array.from(new Set([].concat(Qe(Ie), Qe(P))));
    de(S), S.forEach(function(B) {
      rt(B, !0);
    });
  }, lt = r.useMemo(function() {
    var E = H !== !1 && f !== !1;
    return ve(ve({}, x), {}, {
      flattenOptions: Ve,
      onActiveValue: It,
      defaultActiveFirstOption: $t,
      onSelect: ht,
      menuItemSelectedIcon: Z,
      rawValues: Ie,
      fieldNames: le,
      virtual: E,
      direction: J,
      listHeight: ee,
      listItemHeight: N,
      childrenAsData: ue,
      maxCount: Oe,
      optionRender: D
    });
  }, [Oe, x, Ve, It, $t, ht, Z, Ie, le, H, f, J, ee, N, ue, D]);
  return process.env.NODE_ENV !== "production" && (Bi(e), Vi(L, le)), /* @__PURE__ */ r.createElement(un.Provider, {
    value: lt
  }, /* @__PURE__ */ r.createElement(Gn, Ee({}, Re, {
    // >>> MISC
    id: se,
    prefixCls: a,
    ref: t,
    omitDomProps: Hi,
    mode: o,
    displayValues: Se,
    onDisplayValuesChange: bt,
    direction: J,
    searchValue: _,
    onSearch: ye,
    autoClearSearchValue: $,
    onSearchSplit: at,
    dropdownMatchSelectWidth: f,
    OptionList: qn,
    emptyOptions: !Ve.length,
    activeValue: De,
    activeDescendantId: "".concat(se, "_list_").concat(vt)
  })));
});
process.env.NODE_ENV !== "production" && (Jn.displayName = "Select");
var gn = Jn;
gn.Option = mn;
gn.OptGroup = dn;
const Li = (e) => {
  const {
    componentName: t
  } = e, {
    getPrefixCls: n
  } = fo(ln), o = n("empty");
  switch (t) {
    case "Table":
    case "List":
      return /* @__PURE__ */ j.createElement(Vt, {
        image: Vt.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ j.createElement(Vt, {
        image: Vt.PRESENTED_IMAGE_SIMPLE,
        className: `${o}-small`
      });
    default:
      return /* @__PURE__ */ j.createElement(Vt, null);
  }
}, Fi = Li, Wi = (e) => {
  const n = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: e === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, n), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, n), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, n), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, n), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function Ki(e, t) {
  return e || Wi(t);
}
const Pn = (e) => {
  const {
    optionHeight: t,
    optionFontSize: n,
    optionLineHeight: o,
    optionPadding: i
  } = e;
  return {
    position: "relative",
    display: "block",
    minHeight: t,
    padding: i,
    color: e.colorText,
    fontWeight: "normal",
    fontSize: n,
    lineHeight: o,
    boxSizing: "border-box"
  };
}, Ui = (e) => {
  const {
    antCls: t,
    componentCls: n
  } = e, o = `${n}-item`, i = `&${t}-slide-up-enter${t}-slide-up-enter-active`, a = `&${t}-slide-up-appear${t}-slide-up-appear-active`, l = `&${t}-slide-up-leave${t}-slide-up-leave-active`, s = `${n}-dropdown-placement-`;
  return [
    {
      [`${n}-dropdown`]: Object.assign(Object.assign({}, Kt(e)), {
        position: "absolute",
        top: -9999,
        zIndex: e.zIndexPopup,
        boxSizing: "border-box",
        padding: e.paddingXXS,
        overflow: "hidden",
        fontSize: e.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: e.colorBgElevated,
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        [`
          ${i}${s}bottomLeft,
          ${a}${s}bottomLeft
        `]: {
          animationName: Eo
        },
        [`
          ${i}${s}topLeft,
          ${a}${s}topLeft,
          ${i}${s}topRight,
          ${a}${s}topRight
        `]: {
          animationName: Oo
        },
        [`${l}${s}bottomLeft`]: {
          animationName: No
        },
        [`
          ${l}${s}topLeft,
          ${l}${s}topRight
        `]: {
          animationName: Po
        },
        "&-hidden": {
          display: "none"
        },
        [`${o}`]: Object.assign(Object.assign({}, Pn(e)), {
          cursor: "pointer",
          transition: `background ${e.motionDurationSlow} ease`,
          borderRadius: e.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, nn),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${o}-option-disabled)`]: {
              backgroundColor: e.optionActiveBg
            },
            [`&-selected:not(${o}-option-disabled)`]: {
              color: e.optionSelectedColor,
              fontWeight: e.optionSelectedFontWeight,
              backgroundColor: e.optionSelectedBg,
              [`${o}-option-state`]: {
                color: e.colorPrimary
              },
              [`&:has(+ ${o}-option-selected:not(${o}-option-disabled))`]: {
                borderEndStartRadius: 0,
                borderEndEndRadius: 0,
                [`& + ${o}-option-selected:not(${o}-option-disabled)`]: {
                  borderStartStartRadius: 0,
                  borderStartEndRadius: 0
                }
              }
            },
            "&-disabled": {
              [`&${o}-option-selected`]: {
                backgroundColor: e.colorBgContainerDisabled
              },
              color: e.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: e.calc(e.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, Pn(e)), {
            color: e.colorTextDisabled
          })
        }),
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    Sn(e, "slide-up"),
    Sn(e, "slide-down"),
    wn(e, "move-up"),
    wn(e, "move-down")
  ];
}, Xi = (e) => {
  const {
    multipleSelectItemHeight: t,
    paddingXXS: n,
    lineWidth: o,
    INTERNAL_FIXED_ITEM_MARGIN: i
  } = e, a = e.max(e.calc(n).sub(o).equal(), 0), l = e.max(e.calc(a).sub(i).equal(), 0);
  return {
    basePadding: a,
    containerPadding: l,
    itemHeight: Y(t),
    itemLineHeight: Y(e.calc(t).sub(e.calc(e.lineWidth).mul(2)).equal())
  };
}, Gi = (e) => {
  const {
    multipleSelectItemHeight: t,
    selectHeight: n,
    lineWidth: o
  } = e;
  return e.calc(n).sub(t).div(2).sub(o).equal();
}, qi = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    borderRadiusSM: o,
    motionDurationSlow: i,
    paddingXS: a,
    multipleItemColorDisabled: l,
    multipleItemBorderColorDisabled: s,
    colorIcon: u,
    colorIconHover: g,
    INTERNAL_FIXED_ITEM_MARGIN: d
  } = e;
  return {
    /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */
    // =========================== Overflow ===========================
    [`${t}-selection-overflow`]: {
      position: "relative",
      display: "flex",
      flex: "auto",
      flexWrap: "wrap",
      maxWidth: "100%",
      "&-item": {
        flex: "none",
        alignSelf: "center",
        maxWidth: "100%",
        display: "inline-flex"
      },
      // ======================== Selections ==========================
      [`${t}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        marginBlock: d,
        borderRadius: o,
        cursor: "default",
        transition: `font-size ${i}, line-height ${i}, height ${i}`,
        marginInlineEnd: e.calc(d).mul(2).equal(),
        paddingInlineStart: a,
        paddingInlineEnd: e.calc(a).div(2).equal(),
        [`${t}-disabled&`]: {
          color: l,
          borderColor: s,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: e.calc(a).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, Tn()), {
          display: "inline-flex",
          alignItems: "center",
          color: u,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${n}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: g
          }
        })
      }
    }
  };
}, Ji = (e, t) => {
  const {
    componentCls: n,
    INTERNAL_FIXED_ITEM_MARGIN: o
  } = e, i = `${n}-selection-overflow`, a = e.multipleSelectItemHeight, l = Gi(e), s = t ? `${n}-${t}` : "", u = Xi(e);
  return {
    [`${n}-multiple${s}`]: Object.assign(Object.assign({}, qi(e)), {
      // ========================= Selector =========================
      [`${n}-selector`]: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: u.basePadding,
        paddingBlock: u.containerPadding,
        borderRadius: e.borderRadius,
        [`${n}-disabled&`]: {
          background: e.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${Y(o)} 0`,
          lineHeight: Y(a),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      // ======================== Selections ========================
      [`${n}-selection-item`]: {
        height: u.itemHeight,
        lineHeight: Y(u.itemLineHeight)
      },
      // ========================== Input ==========================
      [`${i}-item + ${i}-item`]: {
        [`${n}-selection-search`]: {
          marginInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      [`${i}-item-suffix`]: {
        height: "100%"
      },
      [`${n}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(l).equal(),
        "\n          &-input,\n          &-mirror\n        ": {
          height: a,
          fontFamily: e.fontFamily,
          lineHeight: Y(a),
          transition: `all ${e.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: e.inputPaddingHorizontalBase,
        insetInlineEnd: e.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${e.motionDurationSlow}`
      }
    })
  };
};
function Zt(e, t) {
  const {
    componentCls: n
  } = e, o = t ? `${n}-${t}` : "", i = {
    [`${n}-multiple${o}`]: {
      fontSize: e.fontSize,
      // ========================= Selector =========================
      [`${n}-selector`]: {
        [`${n}-show-search&`]: {
          cursor: "text"
        }
      },
      [`
        &${n}-show-arrow ${n}-selector,
        &${n}-allow-clear ${n}-selector
      `]: {
        paddingInlineEnd: e.calc(e.fontSizeIcon).add(e.controlPaddingHorizontal).equal()
      }
    }
  };
  return [Ji(e, t), i];
}
const Yi = (e) => {
  const {
    componentCls: t
  } = e, n = Rt(e, {
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.multipleItemHeightSM,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), o = Rt(e, {
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius
  });
  return [
    Zt(e),
    // ======================== Small ========================
    Zt(n, "sm"),
    // Padding
    {
      [`${t}-multiple${t}-sm`]: {
        [`${t}-selection-placeholder`]: {
          insetInline: e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${t}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    Zt(o, "lg")
  ];
};
function kt(e, t) {
  const {
    componentCls: n,
    inputPaddingHorizontalBase: o,
    borderRadius: i
  } = e, a = e.calc(e.controlHeight).sub(e.calc(e.lineWidth).mul(2)).equal(), l = t ? `${n}-${t}` : "";
  return {
    [`${n}-single${l}`]: {
      fontSize: e.fontSize,
      height: e.controlHeight,
      // ========================= Selector =========================
      [`${n}-selector`]: Object.assign(Object.assign({}, Kt(e, !0)), {
        display: "flex",
        borderRadius: i,
        [`${n}-selection-search`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: o,
          insetInlineEnd: o,
          bottom: 0,
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${n}-selection-item,
          ${n}-selection-placeholder
        `]: {
          padding: 0,
          lineHeight: Y(a),
          transition: `all ${e.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${n}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${n}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${n}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${n}-show-arrow ${n}-selection-item,
        &${n}-show-arrow ${n}-selection-placeholder
      `]: {
        paddingInlineEnd: e.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${n}-open ${n}-selection-item`]: {
        color: e.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${n}-customize-input)`]: {
        [`${n}-selector`]: {
          width: "100%",
          height: "100%",
          padding: `0 ${Y(o)}`,
          [`${n}-selection-search-input`]: {
            height: a
          },
          "&:after": {
            lineHeight: Y(a)
          }
        }
      },
      [`&${n}-customize-input`]: {
        [`${n}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${n}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${n}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${Y(o)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function Qi(e) {
  const {
    componentCls: t
  } = e, n = e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal();
  return [
    kt(e),
    // ======================== Small ========================
    // Shared
    kt(Rt(e, {
      controlHeight: e.controlHeightSM,
      borderRadius: e.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${t}-single${t}-sm`]: {
        [`&:not(${t}-customize-input)`]: {
          [`${t}-selection-search`]: {
            insetInlineStart: n,
            insetInlineEnd: n
          },
          [`${t}-selector`]: {
            padding: `0 ${Y(n)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${t}-show-arrow ${t}-selection-search`]: {
            insetInlineEnd: e.calc(n).add(e.calc(e.fontSize).mul(1.5)).equal()
          },
          [`
            &${t}-show-arrow ${t}-selection-item,
            &${t}-show-arrow ${t}-selection-placeholder
          `]: {
            paddingInlineEnd: e.calc(e.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    kt(Rt(e, {
      controlHeight: e.singleItemHeightLG,
      fontSize: e.fontSizeLG,
      borderRadius: e.borderRadiusLG
    }), "lg")
  ];
}
const Zi = (e) => {
  const {
    fontSize: t,
    lineHeight: n,
    lineWidth: o,
    controlHeight: i,
    controlHeightSM: a,
    controlHeightLG: l,
    paddingXXS: s,
    controlPaddingHorizontal: u,
    zIndexPopupBase: g,
    colorText: d,
    fontWeightStrong: m,
    controlItemBgActive: $,
    controlItemBgHover: c,
    colorBgContainer: b,
    colorFillSecondary: v,
    colorBgContainerDisabled: f,
    colorTextDisabled: w
  } = e, p = s * 2, F = o * 2, z = Math.min(i - p, i - F), W = Math.min(a - p, a - F), D = Math.min(l - p, l - F);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(s / 2),
    zIndexPopup: g + 50,
    optionSelectedColor: d,
    optionSelectedFontWeight: m,
    optionSelectedBg: $,
    optionActiveBg: c,
    optionPadding: `${(i - t * n) / 2}px ${u}px`,
    optionFontSize: t,
    optionLineHeight: n,
    optionHeight: i,
    selectorBg: b,
    clearBg: b,
    singleItemHeightLG: l,
    multipleItemBg: v,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: z,
    multipleItemHeightSM: W,
    multipleItemHeightLG: D,
    multipleSelectorBgDisabled: f,
    multipleItemColorDisabled: w,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(e.fontSize * 1.25)
  };
}, Yn = (e, t) => {
  const {
    componentCls: n,
    antCls: o,
    controlOutlineWidth: i
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      border: `${Y(e.lineWidth)} ${e.lineType} ${t.borderColor}`,
      background: e.selectorBg
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${o}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        borderColor: t.hoverBorderHover
      },
      [`${n}-focused& ${n}-selector`]: {
        borderColor: t.activeBorderColor,
        boxShadow: `0 0 0 ${Y(i)} ${t.activeShadowColor}`,
        outline: 0
      }
    }
  };
}, Dn = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, Yn(e, t))
}), ki = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, Yn(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.colorPrimaryHover,
    activeBorderColor: e.colorPrimary,
    activeShadowColor: e.controlOutline
  })), Dn(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeShadowColor: e.colorErrorOutline
  })), Dn(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeShadowColor: e.colorWarningOutline
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${Y(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), Qn = (e, t) => {
  const {
    componentCls: n,
    antCls: o
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      background: t.bg,
      border: `${Y(e.lineWidth)} ${e.lineType} transparent`,
      color: t.color
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${o}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        background: t.hoverBg
      },
      [`${n}-focused& ${n}-selector`]: {
        background: e.selectorBg,
        borderColor: t.activeBorderColor,
        outline: 0
      }
    }
  };
}, Mn = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, Qn(e, t))
}), er = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, Qn(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.colorPrimary,
    color: e.colorText
  })), Mn(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    color: e.colorError
  })), Mn(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        borderColor: e.colorBorder,
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.colorBgContainer,
      border: `${Y(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
    }
  })
}), tr = (e) => ({
  "&-borderless": {
    [`${e.componentCls}-selector`]: {
      background: "transparent",
      borderColor: "transparent"
    },
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${Y(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    },
    // Status
    [`&${e.componentCls}-status-error`]: {
      [`${e.componentCls}-selection-item`]: {
        color: e.colorError
      }
    },
    [`&${e.componentCls}-status-warning`]: {
      [`${e.componentCls}-selection-item`]: {
        color: e.colorWarning
      }
    }
  }
}), nr = (e) => ({
  [e.componentCls]: Object.assign(Object.assign(Object.assign({}, ki(e)), er(e)), tr(e))
}), or = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    position: "relative",
    transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${t}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${t}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, ir = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        "-webkit-appearance": "none"
      }
    }
  };
}, rr = (e) => {
  const {
    antCls: t,
    componentCls: n,
    inputPaddingHorizontalBase: o,
    iconCls: i
  } = e;
  return {
    [n]: Object.assign(Object.assign({}, Kt(e)), {
      position: "relative",
      display: "inline-block",
      cursor: "pointer",
      [`&:not(${n}-customize-input) ${n}-selector`]: Object.assign(Object.assign({}, or(e)), ir(e)),
      // ======================== Selection ========================
      [`${n}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, nn), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${t}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: Object.assign(Object.assign({}, nn), {
        flex: 1,
        color: e.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${n}-arrow`]: Object.assign(Object.assign({}, Tn()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: o,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${e.motionDurationSlow} ease`,
        [i]: {
          verticalAlign: "top",
          transition: `transform ${e.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${n}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${n}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Clear ==========================
      [`${n}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: o,
        zIndex: 1,
        display: "inline-block",
        width: e.fontSizeIcon,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${e.motionDurationMid} ease, opacity ${e.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: e.colorTextTertiary
        }
      },
      "&:hover": {
        [`${n}-clear`]: {
          opacity: 1
        },
        // Should use the following selector, but since `:has` has poor compatibility,
        // we use `:not(:last-child)` instead, which may cause some problems in some cases.
        // [`${componentCls}-arrow:has(+ ${componentCls}-clear)`]: {
        [`${n}-arrow:not(:last-child)`]: {
          opacity: 0
        }
      }
    }),
    // ========================= Feedback ==========================
    [`${n}-has-feedback`]: {
      [`${n}-clear`]: {
        insetInlineEnd: e.calc(o).add(e.fontSize).add(e.paddingXS).equal()
      }
    }
  };
}, ar = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    {
      [t]: {
        // ==================== In Form ====================
        [`&${t}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    rr(e),
    // Single
    Qi(e),
    // Multiple
    Yi(e),
    // Dropdown
    Ui(e),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${t}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    Yo(e, {
      borderElCls: `${t}-selector`,
      focusElCls: `${t}-focused`
    })
  ];
}, lr = Bn("Select", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const o = Rt(e, {
    rootPrefixCls: n,
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [ar(o), nr(o)];
}, Zi, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
});
var cr = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
const sr = cr;
var ur = function(t, n) {
  return /* @__PURE__ */ r.createElement(Ut, Ee({}, t, {
    ref: n,
    icon: sr
  }));
}, Zn = /* @__PURE__ */ r.forwardRef(ur);
process.env.NODE_ENV !== "production" && (Zn.displayName = "DownOutlined");
const dr = Zn;
var mr = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" };
const fr = mr;
var gr = function(t, n) {
  return /* @__PURE__ */ r.createElement(Ut, Ee({}, t, {
    ref: n,
    icon: fr
  }));
}, kn = /* @__PURE__ */ r.forwardRef(gr);
process.env.NODE_ENV !== "production" && (kn.displayName = "SearchOutlined");
const pr = kn;
function vr(e) {
  let {
    suffixIcon: t,
    clearIcon: n,
    menuItemSelectedIcon: o,
    removeIcon: i,
    loading: a,
    multiple: l,
    hasFeedback: s,
    prefixCls: u,
    showSuffixIcon: g,
    feedbackIcon: d,
    showArrow: m,
    componentName: $
  } = e;
  process.env.NODE_ENV !== "production" && Vn($).deprecated(!n, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  const c = n ?? /* @__PURE__ */ r.createElement(Qo, null), b = (p) => t === null && !s && !m ? null : /* @__PURE__ */ r.createElement(r.Fragment, null, g !== !1 && p, s && d);
  let v = null;
  if (t !== void 0)
    v = b(t);
  else if (a)
    v = b(/* @__PURE__ */ r.createElement(ko, {
      spin: !0
    }));
  else {
    const p = `${u}-suffix`;
    v = (F) => {
      let {
        open: z,
        showSearch: W
      } = F;
      return b(z && W ? /* @__PURE__ */ r.createElement(pr, {
        className: p
      }) : /* @__PURE__ */ r.createElement(dr, {
        className: p
      }));
    };
  }
  let f = null;
  o !== void 0 ? f = o : l ? f = /* @__PURE__ */ r.createElement(Ho, null) : f = null;
  let w = null;
  return i !== void 0 ? w = i : w = /* @__PURE__ */ r.createElement(Zo, null), {
    clearIcon: c,
    suffixIcon: v,
    itemIcon: f,
    removeIcon: w
  };
}
function hr(e, t) {
  return t !== void 0 ? t : e !== null;
}
var br = function(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, o = Object.getOwnPropertySymbols(e); i < o.length; i++)
      t.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[i]) && (n[o[i]] = e[o[i]]);
  return n;
};
const eo = "SECRET_COMBOBOX_MODE_DO_NOT_USE", to = (e, t) => {
  var n;
  const {
    prefixCls: o,
    bordered: i,
    className: a,
    rootClassName: l,
    getPopupContainer: s,
    popupClassName: u,
    dropdownClassName: g,
    listHeight: d = 256,
    placement: m,
    listItemHeight: $,
    size: c,
    disabled: b,
    notFoundContent: v,
    status: f,
    builtinPlacements: w,
    dropdownMatchSelectWidth: p,
    popupMatchSelectWidth: F,
    direction: z,
    style: W,
    allowClear: D,
    variant: M,
    dropdownStyle: X,
    transitionName: Z,
    tagRender: H,
    maxCount: J
  } = e, G = br(e, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount"]), {
    getPopupContainer: ee,
    getPrefixCls: I,
    renderEmpty: N,
    direction: te,
    virtual: A,
    popupMatchSelectWidth: C,
    popupOverflow: K,
    select: Q
  } = r.useContext(ln), [, Oe] = jn(), Re = $ ?? (Oe == null ? void 0 : Oe.controlHeight), se = I("select", o), ae = I(), ue = z ?? te, {
    compactSize: Fe,
    compactItemClassnames: le
  } = Ro(se, ue), [Te, We] = Ao("select", M, i), _ = Do(se), [y, x, q] = lr(se, _), O = r.useMemo(() => {
    const {
      mode: De
    } = e;
    if (De !== "combobox")
      return De === eo ? "combobox" : De;
  }, [e.mode]), L = O === "multiple" || O === "tags", h = hr(e.suffixIcon, e.showArrow), ce = (n = F ?? p) !== null && n !== void 0 ? n : C, {
    status: re,
    hasFeedback: me,
    isFormItemInput: be,
    feedbackIcon: Me
  } = r.useContext(Jo), Ke = Fo(re, f);
  let ze;
  v !== void 0 ? ze = v : O === "combobox" ? ze = null : ze = (N == null ? void 0 : N("Select")) || /* @__PURE__ */ r.createElement(Fi, {
    componentName: "Select"
  });
  const {
    suffixIcon: ge,
    itemIcon: Ue,
    removeIcon: Se,
    clearIcon: Ie
  } = vr(Object.assign(Object.assign({}, G), {
    multiple: L,
    hasFeedback: me,
    feedbackIcon: Me,
    showSuffixIcon: h,
    prefixCls: se,
    componentName: "Select"
  })), Ce = D === !0 ? {
    clearIcon: Ie
  } : D, Je = An(G, ["suffixIcon", "itemIcon"]), Ne = xe(u || g, {
    [`${se}-dropdown-${ue}`]: ue === "rtl"
  }, l, q, _, x), Xe = Hn((De) => {
    var we;
    return (we = c ?? Fe) !== null && we !== void 0 ? we : De;
  }), Be = r.useContext(yo), Ve = b ?? Be, de = xe({
    [`${se}-lg`]: Xe === "large",
    [`${se}-sm`]: Xe === "small",
    [`${se}-rtl`]: ue === "rtl",
    [`${se}-${Te}`]: We,
    [`${se}-in-form-item`]: be
  }, Lo(se, Ke, me), le, Q == null ? void 0 : Q.className, a, l, q, _, x), et = r.useMemo(() => m !== void 0 ? m : ue === "rtl" ? "bottomRight" : "bottomLeft", [m, ue]);
  if (process.env.NODE_ENV !== "production") {
    const De = Vn("Select");
    De.deprecated(!g, "dropdownClassName", "popupClassName"), De.deprecated(p === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), process.env.NODE_ENV !== "production" && De(!("showArrow" in e), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null."), De.deprecated(!("bordered" in e), "bordered", "variant"), process.env.NODE_ENV !== "production" && De(!(typeof J < "u" && !L), "usage", "`maxCount` only works with mode `multiple` or `tags`");
  }
  const [Pe] = Vo("SelectLike", X == null ? void 0 : X.zIndex);
  return y(/* @__PURE__ */ r.createElement(gn, Object.assign({
    ref: t,
    virtual: A,
    showSearch: Q == null ? void 0 : Q.showSearch
  }, Je, {
    style: Object.assign(Object.assign({}, Q == null ? void 0 : Q.style), W),
    dropdownMatchSelectWidth: ce,
    transitionName: Mo(ae, "slide-up", Z),
    builtinPlacements: Ki(w, K),
    listHeight: d,
    listItemHeight: Re,
    mode: O,
    prefixCls: se,
    placement: et,
    direction: ue,
    suffixIcon: ge,
    menuItemSelectedIcon: Ue,
    removeIcon: Se,
    allowClear: Ce,
    notFoundContent: ze,
    className: de,
    getPopupContainer: s || ee,
    dropdownClassName: Ne,
    disabled: Ve,
    dropdownStyle: Object.assign(Object.assign({}, X), {
      zIndex: Pe
    }),
    maxCount: L ? J : void 0,
    tagRender: L ? H : void 0
  })));
};
process.env.NODE_ENV !== "production" && (to.displayName = "Select");
const yt = /* @__PURE__ */ r.forwardRef(to), Sr = jo(yt);
yt.SECRET_COMBOBOX_MODE_DO_NOT_USE = eo;
yt.Option = mn;
yt.OptGroup = dn;
yt._InternalPanelDoNotUseOrYouWillBeFired = Sr;
process.env.NODE_ENV !== "production" && (yt.displayName = "Select");
const Gt = yt;
var Cr = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, name: "double-left", theme: "outlined" };
const yr = Cr;
var wr = function(t, n) {
  return /* @__PURE__ */ r.createElement(Ut, Ee({}, t, {
    ref: n,
    icon: yr
  }));
}, no = /* @__PURE__ */ r.forwardRef(wr);
process.env.NODE_ENV !== "production" && (no.displayName = "DoubleLeftOutlined");
const Rn = no;
var $r = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, name: "double-right", theme: "outlined" };
const Ir = $r;
var xr = function(t, n) {
  return /* @__PURE__ */ r.createElement(Ut, Ee({}, t, {
    ref: n,
    icon: Ir
  }));
}, oo = /* @__PURE__ */ r.forwardRef(xr);
process.env.NODE_ENV !== "production" && (oo.displayName = "DoubleRightOutlined");
const zn = oo;
var Er = {
  // Options
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页",
  page_size: "页码"
}, Or = ["10", "20", "50", "100"], io = function(t) {
  var n = t.pageSizeOptions, o = n === void 0 ? Or : n, i = t.locale, a = t.changeSize, l = t.pageSize, s = t.goButton, u = t.quickGo, g = t.rootPrefixCls, d = t.selectComponentClass, m = t.selectPrefixCls, $ = t.disabled, c = t.buildOptionText, b = j.useState(""), v = fe(b, 2), f = v[0], w = v[1], p = function() {
    return !f || Number.isNaN(f) ? void 0 : Number(f);
  }, F = typeof c == "function" ? c : function(I) {
    return "".concat(I, " ").concat(i.items_per_page);
  }, z = function(N) {
    a == null || a(Number(N));
  }, W = function(N) {
    w(N.target.value);
  }, D = function(N) {
    s || f === "" || (w(""), !(N.relatedTarget && (N.relatedTarget.className.indexOf("".concat(g, "-item-link")) >= 0 || N.relatedTarget.className.indexOf("".concat(g, "-item")) >= 0)) && (u == null || u(p())));
  }, M = function(N) {
    f !== "" && (N.keyCode === T.ENTER || N.type === "click") && (w(""), u == null || u(p()));
  }, X = function() {
    return o.some(function(N) {
      return N.toString() === l.toString();
    }) ? o : o.concat([l.toString()]).sort(function(N, te) {
      var A = Number.isNaN(Number(N)) ? 0 : Number(N), C = Number.isNaN(Number(te)) ? 0 : Number(te);
      return A - C;
    });
  }, Z = "".concat(g, "-options");
  if (!a && !u)
    return null;
  var H = null, J = null, G = null;
  if (a && d) {
    var ee = X().map(function(I, N) {
      return /* @__PURE__ */ j.createElement(d.Option, {
        key: N,
        value: I.toString()
      }, F(I));
    });
    H = /* @__PURE__ */ j.createElement(d, {
      disabled: $,
      prefixCls: m,
      showSearch: !1,
      className: "".concat(Z, "-size-changer"),
      optionLabelProp: "children",
      popupMatchSelectWidth: !1,
      value: (l || o[0]).toString(),
      onChange: z,
      getPopupContainer: function(N) {
        return N.parentNode;
      },
      "aria-label": i.page_size,
      defaultOpen: !1
    }, ee);
  }
  return u && (s && (G = typeof s == "boolean" ? /* @__PURE__ */ j.createElement("button", {
    type: "button",
    onClick: M,
    onKeyUp: M,
    disabled: $,
    className: "".concat(Z, "-quick-jumper-button")
  }, i.jump_to_confirm) : /* @__PURE__ */ j.createElement("span", {
    onClick: M,
    onKeyUp: M
  }, s)), J = /* @__PURE__ */ j.createElement("div", {
    className: "".concat(Z, "-quick-jumper")
  }, i.jump_to, /* @__PURE__ */ j.createElement("input", {
    disabled: $,
    type: "text",
    value: f,
    onChange: W,
    onKeyUp: M,
    onBlur: D,
    "aria-label": i.page
  }), i.page, G)), /* @__PURE__ */ j.createElement("li", {
    className: Z
  }, H, J);
};
process.env.NODE_ENV !== "production" && (io.displayName = "Options");
var Mt = function(t) {
  var n, o = t.rootPrefixCls, i = t.page, a = t.active, l = t.className, s = t.showTitle, u = t.onClick, g = t.onKeyPress, d = t.itemRender, m = "".concat(o, "-item"), $ = xe(m, "".concat(m, "-").concat(i), (n = {}, ie(n, "".concat(m, "-active"), a), ie(n, "".concat(m, "-disabled"), !i), n), l), c = function() {
    u(i);
  }, b = function(w) {
    g(w, u, i);
  }, v = d(i, "page", /* @__PURE__ */ j.createElement("a", {
    rel: "nofollow"
  }, i));
  return v ? /* @__PURE__ */ j.createElement("li", {
    title: s ? String(i) : null,
    className: $,
    onClick: c,
    onKeyDown: b,
    tabIndex: 0
  }, v) : null;
};
process.env.NODE_ENV !== "production" && (Mt.displayName = "Pager");
var Nr = function(t, n, o) {
  return o;
};
function en() {
}
function _n(e) {
  var t = Number(e);
  return typeof t == "number" && !Number.isNaN(t) && isFinite(t) && Math.floor(t) === t;
}
function Ct(e, t, n) {
  var o = typeof e > "u" ? t : e;
  return Math.floor((n - 1) / o) + 1;
}
var ro = function(t) {
  var n, o = t.prefixCls, i = o === void 0 ? "rc-pagination" : o, a = t.selectPrefixCls, l = a === void 0 ? "rc-select" : a, s = t.className, u = t.selectComponentClass, g = t.current, d = t.defaultCurrent, m = d === void 0 ? 1 : d, $ = t.total, c = $ === void 0 ? 0 : $, b = t.pageSize, v = t.defaultPageSize, f = v === void 0 ? 10 : v, w = t.onChange, p = w === void 0 ? en : w, F = t.hideOnSinglePage, z = t.align, W = t.showPrevNextJumpers, D = W === void 0 ? !0 : W, M = t.showQuickJumper, X = t.showLessItems, Z = t.showTitle, H = Z === void 0 ? !0 : Z, J = t.onShowSizeChange, G = J === void 0 ? en : J, ee = t.locale, I = ee === void 0 ? Er : ee, N = t.style, te = t.totalBoundaryShowSizeChanger, A = te === void 0 ? 50 : te, C = t.disabled, K = t.simple, Q = t.showTotal, Oe = t.showSizeChanger, Re = t.pageSizeOptions, se = t.itemRender, ae = se === void 0 ? Nr : se, ue = t.jumpPrevIcon, Fe = t.jumpNextIcon, le = t.prevIcon, Te = t.nextIcon, We = j.useRef(null), _ = jt(10, {
    value: b,
    defaultValue: f
  }), y = fe(_, 2), x = y[0], q = y[1], O = jt(1, {
    value: g,
    defaultValue: m,
    postState: function(k) {
      return Math.max(1, Math.min(k, Ct(void 0, x, c)));
    }
  }), L = fe(O, 2), h = L[0], ce = L[1], re = j.useState(h), me = fe(re, 2), be = me[0], Me = me[1];
  tn(function() {
    Me(h);
  }, [h]);
  var Ke = p !== en, ze = "current" in t;
  process.env.NODE_ENV !== "production" && Le(ze ? Ke : !0, "You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.");
  var ge = Math.max(1, h - (X ? 3 : 5)), Ue = Math.min(Ct(void 0, x, c), h + (X ? 3 : 5));
  function Se(R, k) {
    var pe = R || /* @__PURE__ */ j.createElement("button", {
      type: "button",
      "aria-label": k,
      className: "".concat(i, "-item-link")
    });
    return typeof R == "function" && (pe = /* @__PURE__ */ j.createElement(R, ve({}, t))), pe;
  }
  function Ie(R) {
    var k = R.target.value, pe = Ct(void 0, x, c), nt;
    return k === "" ? nt = k : Number.isNaN(Number(k)) ? nt = be : k >= pe ? nt = pe : nt = Number(k), nt;
  }
  function Ce(R) {
    return _n(R) && R !== h && _n(c) && c > 0;
  }
  var Je = c > x ? M : !1;
  function Ne(R) {
    (R.keyCode === T.UP || R.keyCode === T.DOWN) && R.preventDefault();
  }
  function Xe(R) {
    var k = Ie(R);
    switch (k !== be && Me(k), R.keyCode) {
      case T.ENTER:
        de(k);
        break;
      case T.UP:
        de(k - 1);
        break;
      case T.DOWN:
        de(k + 1);
        break;
    }
  }
  function Be(R) {
    de(Ie(R));
  }
  function Ve(R) {
    var k = Ct(R, x, c), pe = h > k && k !== 0 ? k : h;
    q(R), Me(pe), G == null || G(h, R), ce(pe), p == null || p(pe, R);
  }
  function de(R) {
    if (Ce(R) && !C) {
      var k = Ct(void 0, x, c), pe = R;
      return R > k ? pe = k : R < 1 && (pe = 1), pe !== be && Me(pe), ce(pe), p == null || p(pe, x), pe;
    }
    return h;
  }
  var et = h > 1, Pe = h < Ct(void 0, x, c), De = Oe ?? c > A;
  function we() {
    et && de(h - 1);
  }
  function wt() {
    Pe && de(h + 1);
  }
  function pt() {
    de(ge);
  }
  function vt() {
    de(Ue);
  }
  function it(R, k) {
    if (R.key === "Enter" || R.charCode === T.ENTER || R.keyCode === T.ENTER) {
      for (var pe = arguments.length, nt = new Array(pe > 2 ? pe - 2 : 0), Pt = 2; Pt < pe; Pt++)
        nt[Pt - 2] = arguments[Pt];
      k.apply(void 0, nt);
    }
  }
  function $t(R) {
    it(R, we);
  }
  function It(R) {
    it(R, wt);
  }
  function rt(R) {
    it(R, pt);
  }
  function ht(R) {
    it(R, vt);
  }
  function bt(R) {
    var k = ae(R, "prev", Se(le, "prev page"));
    return /* @__PURE__ */ j.isValidElement(k) ? /* @__PURE__ */ j.cloneElement(k, {
      disabled: !et
    }) : k;
  }
  function ye(R) {
    var k = ae(R, "next", Se(Te, "next page"));
    return /* @__PURE__ */ j.isValidElement(k) ? /* @__PURE__ */ j.cloneElement(k, {
      disabled: !Pe
    }) : k;
  }
  function at(R) {
    (R.type === "click" || R.keyCode === T.ENTER) && de(be);
  }
  var lt = null, E = Ht(t, {
    aria: !0,
    data: !0
  }), V = Q && /* @__PURE__ */ j.createElement("li", {
    className: "".concat(i, "-total-text")
  }, Q(c, [c === 0 ? 0 : (h - 1) * x + 1, h * x > c ? c : h * x])), P = null, S = Ct(void 0, x, c);
  if (F && c <= x)
    return null;
  var B = [], oe = {
    rootPrefixCls: i,
    onClick: de,
    onKeyPress: it,
    showTitle: H,
    itemRender: ae,
    page: -1
  }, Ze = h - 1 > 0 ? h - 1 : 0, Ye = h + 1 < S ? h + 1 : S, Ge = M && M.goButton, he = zt(K) === "object" ? K.readOnly : !K, je = Ge, tt = null;
  K && (Ge && (typeof Ge == "boolean" ? je = /* @__PURE__ */ j.createElement("button", {
    type: "button",
    onClick: at,
    onKeyUp: at
  }, I.jump_to_confirm) : je = /* @__PURE__ */ j.createElement("span", {
    onClick: at,
    onKeyUp: at
  }, Ge), je = /* @__PURE__ */ j.createElement("li", {
    title: H ? "".concat(I.jump_to).concat(h, "/").concat(S) : null,
    className: "".concat(i, "-simple-pager")
  }, je)), tt = /* @__PURE__ */ j.createElement("li", {
    title: H ? "".concat(h, "/").concat(S) : null,
    className: "".concat(i, "-simple-pager")
  }, he ? be : /* @__PURE__ */ j.createElement("input", {
    type: "text",
    value: be,
    disabled: C,
    onKeyDown: Ne,
    onKeyUp: Xe,
    onChange: Xe,
    onBlur: Be,
    size: 3
  }), /* @__PURE__ */ j.createElement("span", {
    className: "".concat(i, "-slash")
  }, "/"), S));
  var qe = X ? 1 : 2;
  if (S <= 3 + qe * 2) {
    S || B.push(/* @__PURE__ */ j.createElement(Mt, Ee({}, oe, {
      key: "noPager",
      page: 1,
      className: "".concat(i, "-item-disabled")
    })));
    for (var ut = 1; ut <= S; ut += 1)
      B.push(/* @__PURE__ */ j.createElement(Mt, Ee({}, oe, {
        key: ut,
        page: ut,
        active: h === ut
      })));
  } else {
    var ct = X ? I.prev_3 : I.prev_5, ke = X ? I.next_3 : I.next_5, At = ae(ge, "jump-prev", Se(ue, "prev page")), st = ae(Ue, "jump-next", Se(Fe, "next page"));
    D && (lt = At ? /* @__PURE__ */ j.createElement("li", {
      title: H ? ct : null,
      key: "prev",
      onClick: pt,
      tabIndex: 0,
      onKeyDown: rt,
      className: xe("".concat(i, "-jump-prev"), ie({}, "".concat(i, "-jump-prev-custom-icon"), !!ue))
    }, At) : null, P = st ? /* @__PURE__ */ j.createElement("li", {
      title: H ? ke : null,
      key: "next",
      onClick: vt,
      tabIndex: 0,
      onKeyDown: ht,
      className: xe("".concat(i, "-jump-next"), ie({}, "".concat(i, "-jump-next-custom-icon"), !!Fe))
    }, st) : null);
    var Tt = Math.max(1, h - qe), Bt = Math.min(h + qe, S);
    h - 1 <= qe && (Bt = 1 + qe * 2), S - h <= qe && (Tt = S - qe * 2);
    for (var St = Tt; St <= Bt; St += 1)
      B.push(/* @__PURE__ */ j.createElement(Mt, Ee({}, oe, {
        key: St,
        page: St,
        active: h === St
      })));
    if (h - 1 >= qe * 2 && h !== 3 && (B[0] = /* @__PURE__ */ j.cloneElement(B[0], {
      className: xe("".concat(i, "-item-after-jump-prev"), B[0].props.className)
    }), B.unshift(lt)), S - h >= qe * 2 && h !== S - 2) {
      var Lt = B[B.length - 1];
      B[B.length - 1] = /* @__PURE__ */ j.cloneElement(Lt, {
        className: xe("".concat(i, "-item-before-jump-next"), Lt.props.className)
      }), B.push(P);
    }
    Tt !== 1 && B.unshift(/* @__PURE__ */ j.createElement(Mt, Ee({}, oe, {
      key: 1,
      page: 1
    }))), Bt !== S && B.push(/* @__PURE__ */ j.createElement(Mt, Ee({}, oe, {
      key: S,
      page: S
    })));
  }
  var xt = bt(Ze);
  if (xt) {
    var Et = !et || !S;
    xt = /* @__PURE__ */ j.createElement("li", {
      title: H ? I.prev_page : null,
      onClick: we,
      tabIndex: Et ? null : 0,
      onKeyDown: $t,
      className: xe("".concat(i, "-prev"), ie({}, "".concat(i, "-disabled"), Et)),
      "aria-disabled": Et
    }, xt);
  }
  var Ot = ye(Ye);
  if (Ot) {
    var dt, Nt;
    K ? (dt = !Pe, Nt = et ? 0 : null) : (dt = !Pe || !S, Nt = dt ? null : 0), Ot = /* @__PURE__ */ j.createElement("li", {
      title: H ? I.next_page : null,
      onClick: wt,
      tabIndex: Nt,
      onKeyDown: It,
      className: xe("".concat(i, "-next"), ie({}, "".concat(i, "-disabled"), dt)),
      "aria-disabled": dt
    }, Ot);
  }
  var qt = xe(i, s, (n = {}, ie(n, "".concat(i, "-start"), z === "start"), ie(n, "".concat(i, "-center"), z === "center"), ie(n, "".concat(i, "-end"), z === "end"), ie(n, "".concat(i, "-simple"), K), ie(n, "".concat(i, "-disabled"), C), n));
  return /* @__PURE__ */ j.createElement("ul", Ee({
    className: qt,
    style: N,
    ref: We
  }, E), V, xt, K ? tt : B, Ot, /* @__PURE__ */ j.createElement(io, {
    locale: I,
    rootPrefixCls: i,
    disabled: C,
    selectComponentClass: u,
    selectPrefixCls: l,
    changeSize: De ? Ve : null,
    pageSize: x,
    pageSizeOptions: Re,
    quickGo: Je ? de : null,
    goButton: je
  }));
};
process.env.NODE_ENV !== "production" && (ro.displayName = "Pagination");
const ao = (e) => /* @__PURE__ */ r.createElement(Gt, Object.assign({}, e, {
  showSearch: !0,
  size: "small"
})), lo = (e) => /* @__PURE__ */ r.createElement(Gt, Object.assign({}, e, {
  showSearch: !0,
  size: "middle"
}));
ao.Option = Gt.Option;
lo.Option = Gt.Option;
const Pr = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${t}-disabled`]: {
      cursor: "not-allowed",
      [`${t}-item`]: {
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: e.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: e.colorBorder,
          backgroundColor: e.itemActiveBgDisabled,
          "&:hover, &:active": {
            backgroundColor: e.itemActiveBgDisabled
          },
          a: {
            color: e.itemActiveColorDisabled
          }
        }
      },
      [`${t}-item-link`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${t}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${t}-simple-pager`]: {
        color: e.colorTextDisabled
      },
      [`${t}-jump-prev, ${t}-jump-next`]: {
        [`${t}-item-link-icon`]: {
          opacity: 0
        },
        [`${t}-item-ellipsis`]: {
          opacity: 1
        }
      }
    },
    [`&${t}-simple`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&${t}-disabled ${t}-item-link`]: {
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  };
}, Dr = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`&${t}-mini ${t}-total-text, &${t}-mini ${t}-simple-pager`]: {
      height: e.itemSizeSM,
      lineHeight: Y(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-item`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: Y(e.calc(e.itemSizeSM).sub(2).equal())
    },
    [`&${t}-mini:not(${t}-disabled) ${t}-item:not(${t}-item-active)`]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&:hover": {
        backgroundColor: e.colorBgTextHover
      },
      "&:active": {
        backgroundColor: e.colorBgTextActive
      }
    },
    [`&${t}-mini ${t}-prev, &${t}-mini ${t}-next`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: Y(e.itemSizeSM)
    },
    [`&${t}-mini:not(${t}-disabled)`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&:hover ${t}-item-link`]: {
          backgroundColor: e.colorBgTextHover
        },
        [`&:active ${t}-item-link`]: {
          backgroundColor: e.colorBgTextActive
        },
        [`&${t}-disabled:hover ${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`
    &${t}-mini ${t}-prev ${t}-item-link,
    &${t}-mini ${t}-next ${t}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: e.itemSizeSM,
        lineHeight: Y(e.itemSizeSM)
      }
    },
    [`&${t}-mini ${t}-jump-prev, &${t}-mini ${t}-jump-next`]: {
      height: e.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: Y(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-options`]: {
      marginInlineStart: e.paginationMiniOptionsMarginInlineStart,
      "&-size-changer": {
        top: e.miniOptionsSizeChangerTop
      },
      "&-quick-jumper": {
        height: e.itemSizeSM,
        lineHeight: Y(e.itemSizeSM),
        input: Object.assign(Object.assign({}, Uo(e)), {
          width: e.paginationMiniQuickJumperInputWidth,
          height: e.controlHeightSM
        })
      }
    }
  };
}, Mr = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`
    &${t}-simple ${t}-prev,
    &${t}-simple ${t}-next
    `]: {
      height: e.itemSizeSM,
      lineHeight: Y(e.itemSizeSM),
      verticalAlign: "top",
      [`${t}-item-link`]: {
        height: e.itemSizeSM,
        backgroundColor: "transparent",
        border: 0,
        "&:hover": {
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        },
        "&::after": {
          height: e.itemSizeSM,
          lineHeight: Y(e.itemSizeSM)
        }
      }
    },
    [`&${t}-simple ${t}-simple-pager`]: {
      display: "inline-block",
      height: e.itemSizeSM,
      marginInlineEnd: e.marginXS,
      input: {
        boxSizing: "border-box",
        height: "100%",
        padding: `0 ${Y(e.paginationItemPaddingInline)}`,
        textAlign: "center",
        backgroundColor: e.itemInputBg,
        border: `${Y(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `border-color ${e.motionDurationMid}`,
        color: "inherit",
        "&:hover": {
          borderColor: e.colorPrimary
        },
        "&:focus": {
          borderColor: e.colorPrimaryHover,
          boxShadow: `${Y(e.inputOutlineOffset)} 0 ${Y(e.controlOutlineWidth)} ${e.controlOutline}`
        },
        "&[disabled]": {
          color: e.colorTextDisabled,
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          cursor: "not-allowed"
        }
      }
    }
  };
}, Rr = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return {
    [`${t}-jump-prev, ${t}-jump-next`]: {
      outline: 0,
      [`${t}-item-container`]: {
        position: "relative",
        [`${t}-item-link-icon`]: {
          color: e.colorPrimary,
          fontSize: e.fontSizeSM,
          opacity: 0,
          transition: `all ${e.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${t}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: e.colorTextDisabled,
          fontFamily: "Arial, Helvetica, sans-serif",
          letterSpacing: e.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: e.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${e.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${t}-item-link-icon`]: {
          opacity: 1
        },
        [`${t}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${t}-prev,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      marginInlineEnd: e.marginXS
    },
    [`
    ${t}-prev,
    ${t}-next,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      color: e.colorText,
      fontFamily: e.fontFamily,
      lineHeight: `${Y(e.itemSize)}`,
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: e.borderRadius,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid}`
    },
    [`${t}-prev, ${t}-next`]: {
      fontFamily: "Arial, Helvetica, sans-serif",
      outline: 0,
      button: {
        color: e.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${t}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: e.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${Y(e.lineWidth)} ${e.lineType} transparent`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `all ${e.motionDurationMid}`
      },
      [`&:hover ${t}-item-link`]: {
        backgroundColor: e.colorBgTextHover
      },
      [`&:active ${t}-item-link`]: {
        backgroundColor: e.colorBgTextActive
      },
      [`&${t}-disabled:hover`]: {
        [`${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${t}-slash`]: {
      marginInlineEnd: e.paginationSlashMarginInlineEnd,
      marginInlineStart: e.paginationSlashMarginInlineStart
    },
    [`${t}-options`]: {
      display: "inline-block",
      marginInlineStart: e.margin,
      verticalAlign: "middle",
      "&-size-changer": {
        display: "inline-block",
        width: "auto",
        // https://github.com/ant-design/ant-design/issues/49258
        [`${n}-select-arrow:not(:last-child)`]: {
          opacity: 1
        }
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: e.controlHeight,
        marginInlineStart: e.marginXS,
        lineHeight: Y(e.controlHeight),
        verticalAlign: "top",
        input: Object.assign(Object.assign(Object.assign({}, Xo(e)), Go(e, {
          borderColor: e.colorBorder,
          hoverBorderColor: e.colorPrimaryHover,
          activeBorderColor: e.colorPrimary,
          activeShadow: e.activeShadow
        })), {
          "&[disabled]": Object.assign({}, qo(e)),
          width: e.calc(e.controlHeightLG).mul(1.25).equal(),
          height: e.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: e.marginXS,
          marginInlineEnd: e.marginXS
        })
      }
    }
  };
}, zr = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-item`]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      marginInlineEnd: e.marginXS,
      fontFamily: e.fontFamily,
      lineHeight: Y(e.calc(e.itemSize).sub(2).equal()),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: "transparent",
      border: `${Y(e.lineWidth)} ${e.lineType} transparent`,
      borderRadius: e.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${Y(e.paginationItemPaddingInline)}`,
        color: e.colorText,
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${t}-item-active)`]: {
        "&:hover": {
          transition: `all ${e.motionDurationMid}`,
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        }
      },
      "&-active": {
        fontWeight: e.fontWeightStrong,
        backgroundColor: e.itemActiveBg,
        borderColor: e.colorPrimary,
        a: {
          color: e.colorPrimary
        },
        "&:hover": {
          borderColor: e.colorPrimaryHover
        },
        "&:hover a": {
          color: e.colorPrimaryHover
        }
      }
    }
  };
}, _r = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Kt(e)), {
      display: "flex",
      "&-start": {
        justifyContent: "start"
      },
      "&-center": {
        justifyContent: "center"
      },
      "&-end": {
        justifyContent: "end"
      },
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${t}-total-text`]: {
        display: "inline-block",
        height: e.itemSize,
        marginInlineEnd: e.marginXS,
        lineHeight: Y(e.calc(e.itemSize).sub(2).equal()),
        verticalAlign: "middle"
      }
    }), zr(e)), Rr(e)), Mr(e)), Dr(e)), Pr(e)), {
      // media query style
      [`@media only screen and (max-width: ${e.screenLG}px)`]: {
        [`${t}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${e.screenSM}px)`]: {
        [`${t}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${e.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
}, Tr = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}:not(${t}-disabled)`]: {
      [`${t}-item`]: Object.assign({}, wo(e)),
      [`${t}-jump-prev, ${t}-jump-next`]: {
        "&:focus-visible": Object.assign({
          [`${t}-item-link-icon`]: {
            opacity: 1
          },
          [`${t}-item-ellipsis`]: {
            opacity: 0
          }
        }, bn(e))
      },
      [`${t}-prev, ${t}-next`]: {
        [`&:focus-visible ${t}-item-link`]: Object.assign({}, bn(e))
      }
    }
  };
}, co = (e) => Object.assign({
  itemBg: e.colorBgContainer,
  itemSize: e.controlHeight,
  itemSizeSM: e.controlHeightSM,
  itemActiveBg: e.colorBgContainer,
  itemLinkBg: e.colorBgContainer,
  itemActiveColorDisabled: e.colorTextDisabled,
  itemActiveBgDisabled: e.controlItemBgActiveDisabled,
  itemInputBg: e.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, Wo(e)), so = (e) => Rt(e, {
  inputOutlineOffset: 0,
  paginationMiniOptionsMarginInlineStart: e.calc(e.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: e.calc(e.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: e.calc(e.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: e.calc(e.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: e.marginSM,
  paginationSlashMarginInlineEnd: e.marginSM,
  paginationEllipsisTextIndent: "0.13em"
  // magic for ui experience
}, Ko(e)), Br = Bn("Pagination", (e) => {
  const t = so(e);
  return [_r(t), Tr(t)];
}, co), Vr = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}${t}-bordered${t}-disabled:not(${t}-mini)`]: {
      "&, &:hover": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      "&:focus-visible": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      [`${t}-item, ${t}-item-link`]: {
        backgroundColor: e.colorBgContainerDisabled,
        borderColor: e.colorBorder,
        [`&:hover:not(${t}-item-active)`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          a: {
            color: e.colorTextDisabled
          }
        },
        [`&${t}-item-active`]: {
          backgroundColor: e.itemActiveBgDisabled
        }
      },
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          color: e.colorTextDisabled
        },
        [`${t}-item-link`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder
        }
      }
    },
    [`${t}${t}-bordered:not(${t}-mini)`]: {
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          borderColor: e.colorPrimaryHover,
          backgroundColor: e.itemBg
        },
        [`${t}-item-link`]: {
          backgroundColor: e.itemLinkBg,
          borderColor: e.colorBorder
        },
        [`&:hover ${t}-item-link`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          color: e.colorPrimary
        },
        [`&${t}-disabled`]: {
          [`${t}-item-link`]: {
            borderColor: e.colorBorder,
            color: e.colorTextDisabled
          }
        }
      },
      [`${t}-item`]: {
        backgroundColor: e.itemBg,
        border: `${Y(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        [`&:hover:not(${t}-item-active)`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          a: {
            color: e.colorPrimary
          }
        },
        "&-active": {
          borderColor: e.colorPrimary
        }
      }
    }
  };
}, jr = $o(["Pagination", "bordered"], (e) => {
  const t = so(e);
  return [Vr(t)];
}, co);
var Hr = function(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, o = Object.getOwnPropertySymbols(e); i < o.length; i++)
      t.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[i]) && (n[o[i]] = e[o[i]]);
  return n;
};
const uo = (e) => {
  const {
    align: t,
    prefixCls: n,
    selectPrefixCls: o,
    className: i,
    rootClassName: a,
    style: l,
    size: s,
    locale: u,
    selectComponentClass: g,
    responsive: d,
    showSizeChanger: m
  } = e, $ = Hr(e, ["align", "prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "selectComponentClass", "responsive", "showSizeChanger"]), {
    xs: c
  } = zo(d), [, b] = jn(), {
    getPrefixCls: v,
    direction: f,
    pagination: w = {}
  } = r.useContext(ln), p = v("pagination", n), [F, z, W] = Br(p), D = m ?? w.showSizeChanger, M = r.useMemo(() => {
    const N = /* @__PURE__ */ r.createElement("span", {
      className: `${p}-item-ellipsis`
    }, "•••"), te = /* @__PURE__ */ r.createElement("button", {
      className: `${p}-item-link`,
      type: "button",
      tabIndex: -1
    }, f === "rtl" ? /* @__PURE__ */ r.createElement(Cn, null) : /* @__PURE__ */ r.createElement(yn, null)), A = /* @__PURE__ */ r.createElement("button", {
      className: `${p}-item-link`,
      type: "button",
      tabIndex: -1
    }, f === "rtl" ? /* @__PURE__ */ r.createElement(yn, null) : /* @__PURE__ */ r.createElement(Cn, null)), C = (
      // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
      /* @__PURE__ */ r.createElement("a", {
        className: `${p}-item-link`
      }, /* @__PURE__ */ r.createElement("div", {
        className: `${p}-item-container`
      }, f === "rtl" ? /* @__PURE__ */ r.createElement(zn, {
        className: `${p}-item-link-icon`
      }) : /* @__PURE__ */ r.createElement(Rn, {
        className: `${p}-item-link-icon`
      }), N))
    ), K = (
      // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
      /* @__PURE__ */ r.createElement("a", {
        className: `${p}-item-link`
      }, /* @__PURE__ */ r.createElement("div", {
        className: `${p}-item-container`
      }, f === "rtl" ? /* @__PURE__ */ r.createElement(Rn, {
        className: `${p}-item-link-icon`
      }) : /* @__PURE__ */ r.createElement(zn, {
        className: `${p}-item-link-icon`
      }), N))
    );
    return {
      prevIcon: te,
      nextIcon: A,
      jumpPrevIcon: C,
      jumpNextIcon: K
    };
  }, [f, p]), [X] = ei("Pagination", Io), Z = Object.assign(Object.assign({}, X), u), H = Hn(s), J = H === "small" || !!(c && !H && d), G = v("select", o), ee = xe({
    [`${p}-${t}`]: !!t,
    [`${p}-mini`]: J,
    [`${p}-rtl`]: f === "rtl",
    [`${p}-bordered`]: b.wireframe
  }, w == null ? void 0 : w.className, i, a, z, W), I = Object.assign(Object.assign({}, w == null ? void 0 : w.style), l);
  return F(/* @__PURE__ */ r.createElement(r.Fragment, null, b.wireframe && /* @__PURE__ */ r.createElement(jr, {
    prefixCls: p
  }), /* @__PURE__ */ r.createElement(ro, Object.assign({}, M, $, {
    style: I,
    prefixCls: p,
    selectPrefixCls: G,
    className: ee,
    selectComponentClass: g || (J ? ao : lo),
    locale: Z,
    showSizeChanger: D
  }))));
};
process.env.NODE_ENV !== "production" && (uo.displayName = "Pagination");
const Ar = uo;
function ma(e) {
  return /* @__PURE__ */ mo.jsx(Ar, { ...e });
}
export {
  ma as A,
  pr as S
};
//# sourceMappingURL=AntPagination-DhoHKg4V.mjs.map
